/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApplyDiscount {
  /** @maxLength 50 */
  discount_code: string;
  quote_hash: string;
}

export interface AuthCheckEmailVerificationRetrieveParams {
  /** Email address */
  email: string;
}

export interface BlacklistedEmailDomain {
  /**
   * @maxLength 255
   * @pattern (?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]
   */
  domain: string;
}

export enum BlankEnum {
  Value = "",
}

/**
 * * `EXPRESS` - express
 * * `STANDARD` - standard
 * * `ECONOMY` - economy
 * * `CUSTOM` - custom
 * * `SWIFT` - swift
 */
export enum CategoryEnum {
  EXPRESS = "EXPRESS",
  STANDARD = "STANDARD",
  ECONOMY = "ECONOMY",
  CUSTOM = "CUSTOM",
  SWIFT = "SWIFT",
}

export interface CheckoutResponse {
  session_id: string;
}

export interface CofaceCompanyDataResponse {
  city: string;
  country: string;
  name: string;
  postcode: string;
  reg_id?: string;
  street: string;
  tax_id?: string;
  vat_id: string;
}

export interface CofaceCompanyResponse {
  country?: string | null;
  vat_number: string;
}

export interface Contact {
  /** @maxLength 100 */
  company_name?: string;
  /** Preferred contact method */
  contact_method?: ContactMethodEnum;
  country?: CountryEnum | BlankEnum;
  /**
   * @format email
   * @maxLength 254
   */
  email?: string;
  readonly id: number;
  /** @maxLength 255 */
  name?: string;
  /** @maxLength 128 */
  phone?: string;
}

/**
 * * `email` - Email
 * * `phone` - Phone
 * * `none` - Do Not Contact
 */
export enum ContactMethodEnum {
  Email = "email",
  Phone = "phone",
  None = "none",
}

/**
 * * `AF` - Afghanistan
 * * `AX` - Åland Islands
 * * `AL` - Albania
 * * `DZ` - Algeria
 * * `AS` - American Samoa
 * * `AD` - Andorra
 * * `AO` - Angola
 * * `AI` - Anguilla
 * * `AQ` - Antarctica
 * * `AG` - Antigua and Barbuda
 * * `AR` - Argentina
 * * `AM` - Armenia
 * * `AW` - Aruba
 * * `AU` - Australia
 * * `AT` - Austria
 * * `AZ` - Azerbaijan
 * * `BS` - Bahamas
 * * `BH` - Bahrain
 * * `BD` - Bangladesh
 * * `BB` - Barbados
 * * `BY` - Belarus
 * * `BE` - Belgium
 * * `BZ` - Belize
 * * `BJ` - Benin
 * * `BM` - Bermuda
 * * `BT` - Bhutan
 * * `BO` - Bolivia
 * * `BQ` - Bonaire, Sint Eustatius and Saba
 * * `BA` - Bosnia and Herzegovina
 * * `BW` - Botswana
 * * `BV` - Bouvet Island
 * * `BR` - Brazil
 * * `IO` - British Indian Ocean Territory
 * * `BN` - Brunei
 * * `BG` - Bulgaria
 * * `BF` - Burkina Faso
 * * `BI` - Burundi
 * * `CV` - Cabo Verde
 * * `KH` - Cambodia
 * * `CM` - Cameroon
 * * `CA` - Canada
 * * `KY` - Cayman Islands
 * * `CF` - Central African Republic
 * * `TD` - Chad
 * * `CL` - Chile
 * * `CN` - China
 * * `CX` - Christmas Island
 * * `CC` - Cocos (Keeling) Islands
 * * `CO` - Colombia
 * * `KM` - Comoros
 * * `CG` - Congo
 * * `CD` - Congo (the Democratic Republic of the)
 * * `CK` - Cook Islands
 * * `CR` - Costa Rica
 * * `CI` - Côte d'Ivoire
 * * `HR` - Croatia
 * * `CU` - Cuba
 * * `CW` - Curaçao
 * * `CY` - Cyprus
 * * `CZ` - Czechia
 * * `DK` - Denmark
 * * `DJ` - Djibouti
 * * `DM` - Dominica
 * * `DO` - Dominican Republic
 * * `EC` - Ecuador
 * * `EG` - Egypt
 * * `SV` - El Salvador
 * * `GQ` - Equatorial Guinea
 * * `ER` - Eritrea
 * * `EE` - Estonia
 * * `SZ` - Eswatini
 * * `ET` - Ethiopia
 * * `FK` - Falkland Islands (Malvinas)
 * * `FO` - Faroe Islands
 * * `FJ` - Fiji
 * * `FI` - Finland
 * * `FR` - France
 * * `GF` - French Guiana
 * * `PF` - French Polynesia
 * * `TF` - French Southern Territories
 * * `GA` - Gabon
 * * `GM` - Gambia
 * * `GE` - Georgia
 * * `DE` - Germany
 * * `GH` - Ghana
 * * `GI` - Gibraltar
 * * `GR` - Greece
 * * `GL` - Greenland
 * * `GD` - Grenada
 * * `GP` - Guadeloupe
 * * `GU` - Guam
 * * `GT` - Guatemala
 * * `GG` - Guernsey
 * * `GN` - Guinea
 * * `GW` - Guinea-Bissau
 * * `GY` - Guyana
 * * `HT` - Haiti
 * * `HM` - Heard Island and McDonald Islands
 * * `VA` - Holy See
 * * `HN` - Honduras
 * * `HK` - Hong Kong
 * * `HU` - Hungary
 * * `IS` - Iceland
 * * `IN` - India
 * * `ID` - Indonesia
 * * `IR` - Iran
 * * `IQ` - Iraq
 * * `IE` - Ireland
 * * `IM` - Isle of Man
 * * `IL` - Israel
 * * `IT` - Italy
 * * `JM` - Jamaica
 * * `JP` - Japan
 * * `JE` - Jersey
 * * `JO` - Jordan
 * * `KZ` - Kazakhstan
 * * `KE` - Kenya
 * * `KI` - Kiribati
 * * `KW` - Kuwait
 * * `KG` - Kyrgyzstan
 * * `LA` - Laos
 * * `LV` - Latvia
 * * `LB` - Lebanon
 * * `LS` - Lesotho
 * * `LR` - Liberia
 * * `LY` - Libya
 * * `LI` - Liechtenstein
 * * `LT` - Lithuania
 * * `LU` - Luxembourg
 * * `MO` - Macao
 * * `MG` - Madagascar
 * * `MW` - Malawi
 * * `MY` - Malaysia
 * * `MV` - Maldives
 * * `ML` - Mali
 * * `MT` - Malta
 * * `MH` - Marshall Islands
 * * `MQ` - Martinique
 * * `MR` - Mauritania
 * * `MU` - Mauritius
 * * `YT` - Mayotte
 * * `MX` - Mexico
 * * `FM` - Micronesia
 * * `MD` - Moldova
 * * `MC` - Monaco
 * * `MN` - Mongolia
 * * `ME` - Montenegro
 * * `MS` - Montserrat
 * * `MA` - Morocco
 * * `MZ` - Mozambique
 * * `MM` - Myanmar
 * * `NA` - Namibia
 * * `NR` - Nauru
 * * `NP` - Nepal
 * * `NL` - Netherlands
 * * `NC` - New Caledonia
 * * `NZ` - New Zealand
 * * `NI` - Nicaragua
 * * `NE` - Niger
 * * `NG` - Nigeria
 * * `NU` - Niue
 * * `NF` - Norfolk Island
 * * `KP` - North Korea
 * * `MK` - North Macedonia
 * * `MP` - Northern Mariana Islands
 * * `NO` - Norway
 * * `OM` - Oman
 * * `PK` - Pakistan
 * * `PW` - Palau
 * * `PS` - Palestine, State of
 * * `PA` - Panama
 * * `PG` - Papua New Guinea
 * * `PY` - Paraguay
 * * `PE` - Peru
 * * `PH` - Philippines
 * * `PN` - Pitcairn
 * * `PL` - Poland
 * * `PT` - Portugal
 * * `PR` - Puerto Rico
 * * `QA` - Qatar
 * * `RE` - Réunion
 * * `RO` - Romania
 * * `RU` - Russia
 * * `RW` - Rwanda
 * * `BL` - Saint Barthélemy
 * * `SH` - Saint Helena, Ascension and Tristan da Cunha
 * * `KN` - Saint Kitts and Nevis
 * * `LC` - Saint Lucia
 * * `MF` - Saint Martin (French part)
 * * `PM` - Saint Pierre and Miquelon
 * * `VC` - Saint Vincent and the Grenadines
 * * `WS` - Samoa
 * * `SM` - San Marino
 * * `ST` - Sao Tome and Principe
 * * `SA` - Saudi Arabia
 * * `SN` - Senegal
 * * `RS` - Serbia
 * * `SC` - Seychelles
 * * `SL` - Sierra Leone
 * * `SG` - Singapore
 * * `SX` - Sint Maarten (Dutch part)
 * * `SK` - Slovakia
 * * `SI` - Slovenia
 * * `SB` - Solomon Islands
 * * `SO` - Somalia
 * * `ZA` - South Africa
 * * `GS` - South Georgia and the South Sandwich Islands
 * * `KR` - South Korea
 * * `SS` - South Sudan
 * * `ES` - Spain
 * * `LK` - Sri Lanka
 * * `SD` - Sudan
 * * `SR` - Suriname
 * * `SJ` - Svalbard and Jan Mayen
 * * `SE` - Sweden
 * * `CH` - Switzerland
 * * `SY` - Syria
 * * `TW` - Taiwan
 * * `TJ` - Tajikistan
 * * `TZ` - Tanzania
 * * `TH` - Thailand
 * * `TL` - Timor-Leste
 * * `TG` - Togo
 * * `TK` - Tokelau
 * * `TO` - Tonga
 * * `TT` - Trinidad and Tobago
 * * `TN` - Tunisia
 * * `TR` - Türkiye
 * * `TM` - Turkmenistan
 * * `TC` - Turks and Caicos Islands
 * * `TV` - Tuvalu
 * * `UG` - Uganda
 * * `UA` - Ukraine
 * * `AE` - United Arab Emirates
 * * `GB` - United Kingdom
 * * `UM` - United States Minor Outlying Islands
 * * `US` - United States of America
 * * `UY` - Uruguay
 * * `UZ` - Uzbekistan
 * * `VU` - Vanuatu
 * * `VE` - Venezuela
 * * `VN` - Vietnam
 * * `VG` - Virgin Islands (British)
 * * `VI` - Virgin Islands (U.S.)
 * * `WF` - Wallis and Futuna
 * * `EH` - Western Sahara
 * * `YE` - Yemen
 * * `ZM` - Zambia
 * * `ZW` - Zimbabwe
 */
export enum CountryEnum {
  AF = "AF",
  AX = "AX",
  AL = "AL",
  DZ = "DZ",
  AS = "AS",
  AD = "AD",
  AO = "AO",
  AI = "AI",
  AQ = "AQ",
  AG = "AG",
  AR = "AR",
  AM = "AM",
  AW = "AW",
  AU = "AU",
  AT = "AT",
  AZ = "AZ",
  BS = "BS",
  BH = "BH",
  BD = "BD",
  BB = "BB",
  BY = "BY",
  BE = "BE",
  BZ = "BZ",
  BJ = "BJ",
  BM = "BM",
  BT = "BT",
  BO = "BO",
  BQ = "BQ",
  BA = "BA",
  BW = "BW",
  BV = "BV",
  BR = "BR",
  IO = "IO",
  BN = "BN",
  BG = "BG",
  BF = "BF",
  BI = "BI",
  CV = "CV",
  KH = "KH",
  CM = "CM",
  CA = "CA",
  KY = "KY",
  CF = "CF",
  TD = "TD",
  CL = "CL",
  CN = "CN",
  CX = "CX",
  CC = "CC",
  CO = "CO",
  KM = "KM",
  CG = "CG",
  CD = "CD",
  CK = "CK",
  CR = "CR",
  CI = "CI",
  HR = "HR",
  CU = "CU",
  CW = "CW",
  CY = "CY",
  CZ = "CZ",
  DK = "DK",
  DJ = "DJ",
  DM = "DM",
  DO = "DO",
  EC = "EC",
  EG = "EG",
  SV = "SV",
  GQ = "GQ",
  ER = "ER",
  EE = "EE",
  SZ = "SZ",
  ET = "ET",
  FK = "FK",
  FO = "FO",
  FJ = "FJ",
  FI = "FI",
  FR = "FR",
  GF = "GF",
  PF = "PF",
  TF = "TF",
  GA = "GA",
  GM = "GM",
  GE = "GE",
  DE = "DE",
  GH = "GH",
  GI = "GI",
  GR = "GR",
  GL = "GL",
  GD = "GD",
  GP = "GP",
  GU = "GU",
  GT = "GT",
  GG = "GG",
  GN = "GN",
  GW = "GW",
  GY = "GY",
  HT = "HT",
  HM = "HM",
  VA = "VA",
  HN = "HN",
  HK = "HK",
  HU = "HU",
  IS = "IS",
  IN = "IN",
  ID = "ID",
  IR = "IR",
  IQ = "IQ",
  IE = "IE",
  IM = "IM",
  IL = "IL",
  IT = "IT",
  JM = "JM",
  JP = "JP",
  JE = "JE",
  JO = "JO",
  KZ = "KZ",
  KE = "KE",
  KI = "KI",
  KW = "KW",
  KG = "KG",
  LA = "LA",
  LV = "LV",
  LB = "LB",
  LS = "LS",
  LR = "LR",
  LY = "LY",
  LI = "LI",
  LT = "LT",
  LU = "LU",
  MO = "MO",
  MG = "MG",
  MW = "MW",
  MY = "MY",
  MV = "MV",
  ML = "ML",
  MT = "MT",
  MH = "MH",
  MQ = "MQ",
  MR = "MR",
  MU = "MU",
  YT = "YT",
  MX = "MX",
  FM = "FM",
  MD = "MD",
  MC = "MC",
  MN = "MN",
  ME = "ME",
  MS = "MS",
  MA = "MA",
  MZ = "MZ",
  MM = "MM",
  NA = "NA",
  NR = "NR",
  NP = "NP",
  NL = "NL",
  NC = "NC",
  NZ = "NZ",
  NI = "NI",
  NE = "NE",
  NG = "NG",
  NU = "NU",
  NF = "NF",
  KP = "KP",
  MK = "MK",
  MP = "MP",
  NO = "NO",
  OM = "OM",
  PK = "PK",
  PW = "PW",
  PS = "PS",
  PA = "PA",
  PG = "PG",
  PY = "PY",
  PE = "PE",
  PH = "PH",
  PN = "PN",
  PL = "PL",
  PT = "PT",
  PR = "PR",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  BL = "BL",
  SH = "SH",
  KN = "KN",
  LC = "LC",
  MF = "MF",
  PM = "PM",
  VC = "VC",
  WS = "WS",
  SM = "SM",
  ST = "ST",
  SA = "SA",
  SN = "SN",
  RS = "RS",
  SC = "SC",
  SL = "SL",
  SG = "SG",
  SX = "SX",
  SK = "SK",
  SI = "SI",
  SB = "SB",
  SO = "SO",
  ZA = "ZA",
  GS = "GS",
  KR = "KR",
  SS = "SS",
  ES = "ES",
  LK = "LK",
  SD = "SD",
  SR = "SR",
  SJ = "SJ",
  SE = "SE",
  CH = "CH",
  SY = "SY",
  TW = "TW",
  TJ = "TJ",
  TZ = "TZ",
  TH = "TH",
  TL = "TL",
  TG = "TG",
  TK = "TK",
  TO = "TO",
  TT = "TT",
  TN = "TN",
  TR = "TR",
  TM = "TM",
  TC = "TC",
  TV = "TV",
  UG = "UG",
  UA = "UA",
  AE = "AE",
  GB = "GB",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VU = "VU",
  VE = "VE",
  VN = "VN",
  VG = "VG",
  VI = "VI",
  WF = "WF",
  EH = "EH",
  YE = "YE",
  ZM = "ZM",
  ZW = "ZW",
}

export interface CustomLogin {
  /** @format email */
  email?: string;
  password: string;
  username?: string;
}

export interface DefaultPriceResponse {
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly default_price: string;
  readonly loading_status: string;
  readonly quote_custom: boolean;
}

/**
 * The switches the SPA branches on, from the settings singleton.
 *
 * Add a field here only when the SPA needs it: this endpoint is AllowAny.
 */
export interface DefaultPriceSettings {
  /** Off hides the loyalty program everywhere: the navbar entry and the /workspace loyalty pages disappear from the app, admins cannot grant the loyalty member permission, and the loyalty API endpoints return 403. Stored per-user permissions are left untouched, so turning this back on restores exactly who had access before. */
  loyalty_program_enabled?: boolean;
  /** Show or hide default price */
  show_price?: boolean;
}

export interface Discount {
  /**
   * Discount Amount
   * Specify the amount for flat discount or percentage value (0-100) for percentage discount.
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  amount: string;
  /**
   * Discount Code
   * @maxLength 50
   */
  code: string;
  /**
   * * `flat` - Flat amount
   * * `percent` - Percentage
   */
  discount_type?: DiscountTypeEnum;
  /**
   * Discount Name
   * @maxLength 100
   */
  name: string;
}

/**
 * * `flat` - Flat amount
 * * `percent` - Percentage
 */
export enum DiscountTypeEnum {
  Flat = "flat",
  Percent = "percent",
}

/** Adds nested create feature */
export interface DiscountUsage {
  readonly discount: Discount;
  /** @format date-time */
  readonly used_on: string;
}

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 *     class Child(models.Model):
 *     field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 *     child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 *     class Meta:
 *         model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 *     child = ChildSerializer()
 *
 *     class Meta:
 *         model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export interface EmailPreferenceGroup {
  description?: string;
  readonly id: number;
  /** @maxLength 50 */
  key: string;
  /** @maxLength 100 */
  name: string;
  /**
   * @min 0
   * @max 2147483647
   */
  order?: number;
}

/**
 * * `admin_access_approved` - Admin access approved
 * * `admin_access_rejected` - Admin access rejected
 * * `join_request_received` - Join request received
 * * `join_request_approved` - Join request approved
 * * `join_request_rejected` - Join request rejected
 */
export enum EventEnum {
  AdminAccessApproved = "admin_access_approved",
  AdminAccessRejected = "admin_access_rejected",
  JoinRequestReceived = "join_request_received",
  JoinRequestApproved = "join_request_approved",
  JoinRequestRejected = "join_request_rejected",
}

/** Adds nested create feature */
export interface Feedback {
  /** @format date-time */
  readonly created_at: string;
  feedback_text: string;
  readonly id: number;
  /** @format date-time */
  readonly updated_at: string | null;
  /** Full user serializer with name field - your original UserSerializer */
  user?: User;
  utm_parameters?: Utm;
}

export enum Format {
  Json = "json",
  Yaml = "yaml",
}

export interface Good {
  /**
   * @min 0
   * @max 2147483647
   */
  count?: number | null;
  /** @format date-time */
  readonly created_at: string;
  /**
   * cm
   * @min 0
   * @max 9999
   */
  height?: number | null;
  readonly id: number;
  /**
   * cm
   * @min 0
   * @max 9999
   */
  length?: number | null;
  /**
   * * `Entire Vehicle` - Entire Vehicle
   * * `Euro Pallet` - Euro Pallet
   * * `Industrial Pallet` - Industrial Pallet
   * * `Euro Gitterbox` - Euro Gitterbox
   * * `IBC Container` - IBC Container
   * * `Custom` - Custom
   */
  package_type?: PackageTypeEnum;
  /** stackable packaging */
  stackable?: boolean;
  /**
   * Weight
   * kg
   * @min 0
   * @max 24000
   */
  unit_weight?: number | null;
  /** @format date-time */
  readonly updated_at: string | null;
  /**
   * kg
   * @min 0
   * @max 24000
   */
  weight_limit?: number | null;
  /**
   * cm
   * @min 0
   * @max 9999
   */
  width?: number | null;
}

/** Serializer for JWT authentication. */
export interface JWT {
  access: string;
  refresh: string;
  /** Overlays company fields from the active workspace onto the User JSON response. */
  user: UserDetails;
}

/**
 * The sign-in state the Swida landing shows in its header. A signed-out
 * answer carries ``logged_in`` alone.
 */
export interface LandingStatus {
  company_name?: string;
  /** @format email */
  email?: string;
  logged_in: boolean;
  /**
   * * `personal` - Personal
   * * `company` - Company
   */
  workspace_type?: WorkspaceTypeEnum;
}

export enum Lang {
  De = "de",
  En = "en",
}

/**
 * * `info` - Info
 * * `success` - Success
 * * `error` - Error
 */
export enum LevelEnum {
  Info = "info",
  Success = "success",
  Error = "error",
}

/**
 * * `FITS` - Fits
 * * `WEIGHT_EXCEEDED` - Weight Exceeded
 * * `LENGTH_EXCEEDED` - Length Exceeded
 * * `WIDTH_EXCEEDED` - Width Exceeded
 * * `HEIGHT_EXCEEDED` - Height Exceeded
 * * `LENGTH_MISSING` - Length Missing
 * * `WIDTH_MISSING` - Width Missing
 * * `HEIGHT_MISSING` - Height Missing
 * * `WEIGHT_MISSING` - Weight Missing
 * * `GOODS_MISSING` - Goods Missing
 * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
 * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
 * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
 * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
 * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
 * * `UNKNOWN` - Unknown Status
 */
export enum LoadingStatusEnum {
  FITS = "FITS",
  WEIGHT_EXCEEDED = "WEIGHT_EXCEEDED",
  LENGTH_EXCEEDED = "LENGTH_EXCEEDED",
  WIDTH_EXCEEDED = "WIDTH_EXCEEDED",
  HEIGHT_EXCEEDED = "HEIGHT_EXCEEDED",
  LENGTH_MISSING = "LENGTH_MISSING",
  WIDTH_MISSING = "WIDTH_MISSING",
  HEIGHT_MISSING = "HEIGHT_MISSING",
  WEIGHT_MISSING = "WEIGHT_MISSING",
  GOODS_MISSING = "GOODS_MISSING",
  FLOOR_SPACE_EXCEEDED = "FLOOR_SPACE_EXCEEDED",
  VEHICLE_LENGTH_MISSING = "VEHICLE_LENGTH_MISSING",
  VEHICLE_WIDTH_MISSING = "VEHICLE_WIDTH_MISSING",
  VEHICLE_HEIGHT_MISSING = "VEHICLE_HEIGHT_MISSING",
  VEHICLE_WEIGHT_MISSING = "VEHICLE_WEIGHT_MISSING",
  UNKNOWN = "UNKNOWN",
}

export interface Location {
  country: string;
  /** @format double */
  lat: number;
  /** @format double */
  lng: number;
}

export interface NewsletterSubscribe {
  /** @format email */
  email: string;
}

/** Read-only representation of an in-app notification. */
export interface Notification {
  /** @format date-time */
  readonly created_at: string;
  readonly data: Record<string, any>;
  readonly event: EventEnum;
  readonly id: number;
  readonly is_read: boolean;
  readonly level: LevelEnum;
  readonly message: string;
  readonly title: string;
}

export interface NotificationUnreadCount {
  count: number;
}

export type NullEnum = null;

/** Adds nested create feature */
export interface Order {
  /** Full user serializer with name field - your original UserSerializer */
  manager?: User;
  /**
   * @min 0
   * @max 2147483647
   */
  offer_id?: number | null;
  options?: Transport[];
  /** @maxLength 255 */
  order_number?: string | null;
  quote_id: number;
  /**
   * * `PENDING` - pending
   * * `EXPIRED` - expired
   * * `CLOSED` - closed
   * * `PROCESSING` - processing
   * * `DONE` - done
   * * `CANCELLED` - cancelled
   */
  status?: OrderStatusEnum;
  /**
   * * `SEARCHING_FOR_THE_VEHICLE` - Searching for the vehicle
   * * `VEHICLE_FOUND` - Vehicle found
   * * `LOADED` - Loaded
   * * `ON_ROAD` - On Road
   * * `UNLOADED` - Unloaded
   */
  transport_progress?: TransportProgressEnum;
  readonly transports: Transport[];
  waypoints?: OrderWaypoint[];
}

/**
 * * `PENDING` - pending
 * * `EXPIRED` - expired
 * * `CLOSED` - closed
 * * `PROCESSING` - processing
 * * `DONE` - done
 * * `CANCELLED` - cancelled
 */
export enum OrderStatusEnum {
  PENDING = "PENDING",
  EXPIRED = "EXPIRED",
  CLOSED = "CLOSED",
  PROCESSING = "PROCESSING",
  DONE = "DONE",
  CANCELLED = "CANCELLED",
}

export interface OrderWaypoint {
  datetime?: Record<string, string> | null;
  /**
   * * `pickup` - pickup
   * * `delivery` - delivery
   */
  type: TypeEnum;
}

/**
 * * `SWIDA` - Swida
 * * `TRANSPORTLY` - Transportly
 */
export enum OriginEnum {
  SWIDA = "SWIDA",
  TRANSPORTLY = "TRANSPORTLY",
}

/**
 * * `Entire Vehicle` - Entire Vehicle
 * * `Euro Pallet` - Euro Pallet
 * * `Industrial Pallet` - Industrial Pallet
 * * `Euro Gitterbox` - Euro Gitterbox
 * * `IBC Container` - IBC Container
 * * `Custom` - Custom
 */
export enum PackageTypeEnum {
  EntireVehicle = "Entire Vehicle",
  EuroPallet = "Euro Pallet",
  IndustrialPallet = "Industrial Pallet",
  EuroGitterbox = "Euro Gitterbox",
  IBCContainer = "IBC Container",
  Custom = "Custom",
}

export interface PartnerQuoteResponse {
  quote_hash: string;
  /** @format uri */
  url: string;
}

export interface PasswordChange {
  /** @maxLength 128 */
  new_password1: string;
  /** @maxLength 128 */
  new_password2: string;
  /** @maxLength 128 */
  old_password: string;
}

/** Serializer for requesting a password reset e-mail. */
export interface PasswordReset {
  /** @format email */
  email: string;
}

/** Serializer for confirming a password reset attempt. */
export interface PasswordResetConfirm {
  /** @maxLength 128 */
  new_password1: string;
  /** @maxLength 128 */
  new_password2: string;
  token: string;
  uid: string;
}

/** Adds nested create feature */
export interface PatchedOrder {
  /** Full user serializer with name field - your original UserSerializer */
  manager?: User;
  /**
   * @min 0
   * @max 2147483647
   */
  offer_id?: number | null;
  options?: Transport[];
  /** @maxLength 255 */
  order_number?: string | null;
  quote_id?: number;
  /**
   * * `PENDING` - pending
   * * `EXPIRED` - expired
   * * `CLOSED` - closed
   * * `PROCESSING` - processing
   * * `DONE` - done
   * * `CANCELLED` - cancelled
   */
  status?: OrderStatusEnum;
  /**
   * * `SEARCHING_FOR_THE_VEHICLE` - Searching for the vehicle
   * * `VEHICLE_FOUND` - Vehicle found
   * * `LOADED` - Loaded
   * * `ON_ROAD` - On Road
   * * `UNLOADED` - Unloaded
   */
  transport_progress?: TransportProgressEnum;
  readonly transports?: Transport[];
  waypoints?: OrderWaypoint[];
}

/** Adds nested create feature */
export interface PatchedQuoteByHash {
  readonly billing_info?: Record<string, any>;
  contact?: number | null;
  /** @format date-time */
  readonly created_at?: string;
  created_by_manager?: boolean;
  default_price_option?: number | null;
  discount_usage?: DiscountUsage[];
  /**
   * km
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  distance?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  duration?: string | null;
  /** @format date-time */
  expiration_time?: string | null;
  /** Full truck load */
  ftl?: boolean;
  readonly goods?: Good[];
  /**
   * Hash key
   * @maxLength 64
   */
  hash?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  insurance_limit?: string | null;
  is_magic_link_visited?: boolean;
  /**
   * Result of the load fitting calculation from the Pricer API.
   *
   * * `FITS` - Fits
   * * `WEIGHT_EXCEEDED` - Weight Exceeded
   * * `LENGTH_EXCEEDED` - Length Exceeded
   * * `WIDTH_EXCEEDED` - Width Exceeded
   * * `HEIGHT_EXCEEDED` - Height Exceeded
   * * `LENGTH_MISSING` - Length Missing
   * * `WIDTH_MISSING` - Width Missing
   * * `HEIGHT_MISSING` - Height Missing
   * * `WEIGHT_MISSING` - Weight Missing
   * * `GOODS_MISSING` - Goods Missing
   * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
   * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
   * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
   * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
   * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
   * * `UNKNOWN` - Unknown Status
   */
  loading_status?: LoadingStatusEnum | BlankEnum | NullEnum | null;
  /** Operator */
  manager_account?: number | null;
  /** Notes */
  note?: string;
  notify_on_app_launch?: boolean;
  /** @format date-time */
  paid_datetime?: string | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  polyline?: string | null;
  /** @format date-time */
  price_option_set_time?: string | null;
  readonly price_options?: PriceOption[];
  /** Custom quote */
  quote_custom?: boolean;
  readonly selected_price_option?: PriceOption;
  special_requirements?: SpecialRequirements;
  /**
   * * `DRAFT` - Draft
   * * `PRICEABLE` - Priceable
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `WITH_ORDER` - With Order
   */
  state?: StateEnum;
  /** @format date-time */
  readonly updated_at?: string | null;
  /** Full user serializer with name field - your original UserSerializer */
  user?: User;
  utm_parameters?: Utm;
  /** @format uuid */
  uuid?: string;
  vehicle_type?: VehicleTypeEnum | BlankEnum;
  waypoints?: Waypoint[];
}

/** Base quote serializer without user field */
export interface PatchedQuoteByID {
  /** Billing information */
  billing_info?: number | null;
  contact?: Contact;
  /** @format date-time */
  readonly created_at?: string;
  created_by_manager?: boolean;
  default_price_option?: number | null;
  /**
   * km
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  distance?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  duration?: string | null;
  /** @format date-time */
  expiration_time?: string | null;
  /** Full truck load */
  ftl?: boolean;
  goods?: Good[];
  readonly id?: number;
  is_magic_link_visited?: boolean;
  /**
   * Result of the load fitting calculation from the Pricer API.
   *
   * * `FITS` - Fits
   * * `WEIGHT_EXCEEDED` - Weight Exceeded
   * * `LENGTH_EXCEEDED` - Length Exceeded
   * * `WIDTH_EXCEEDED` - Width Exceeded
   * * `HEIGHT_EXCEEDED` - Height Exceeded
   * * `LENGTH_MISSING` - Length Missing
   * * `WIDTH_MISSING` - Width Missing
   * * `HEIGHT_MISSING` - Height Missing
   * * `WEIGHT_MISSING` - Weight Missing
   * * `GOODS_MISSING` - Goods Missing
   * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
   * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
   * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
   * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
   * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
   * * `UNKNOWN` - Unknown Status
   */
  loading_status?: LoadingStatusEnum | BlankEnum | NullEnum | null;
  /** Operator */
  manager_account?: number | null;
  /** Notes */
  note?: string;
  notify_on_app_launch?: boolean;
  polyline?: string | null;
  /** @format date-time */
  price_option_set_time?: string | null;
  /** Custom quote */
  quote_custom?: boolean;
  selected_price_option?: number | null;
  special_requirements?: SpecialRequirements;
  /**
   * * `DRAFT` - Draft
   * * `PRICEABLE` - Priceable
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `WITH_ORDER` - With Order
   */
  state?: StateEnum;
  /** @format date-time */
  readonly updated_at?: string | null;
  user?: number | null;
  utm_parameters?: Utm;
  /** @format uuid */
  uuid?: string;
  vehicle_type?: VehicleTypeEnum | BlankEnum;
  waypoints?: Waypoint[];
}

/** Adds nested create feature */
export interface PatchedUpdateQuotePricing {
  goods?: Good[];
  special_requirements?: SpecialRequirements;
  /**
   * * `VAN` - VAN
   * * `SMALL_LORRY` - SMALL_LORRY
   * * `BIG_LORRY` - BIG_LORRY
   * * `LKW` - LKW
   */
  vehicle_type?: VehicleTypeEnum;
}

/** Full user serializer with name field - your original UserSerializer */
export interface PatchedUser {
  /**
   * Can select weekends and outside working hours
   * Allows user to select pickup/delivery times on weekends and outside standard working hours.
   */
  can_select_extended_hours?: boolean;
  /** @maxLength 100 */
  city?: string;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum | NullEnum | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /** User is company? */
  is_company?: boolean;
  /** User is vat payer? */
  is_vat_payer?: boolean;
  /**
   * User name
   * @maxLength 255
   */
  name?: string;
  /** @maxLength 128 */
  phone?: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** Language */
  preferred_language?: PreferredLanguageEnum | BlankEnum;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  timezone?: string;
  /** @maxLength 150 */
  vat_number?: string;
}

/** Overlays company fields from the active workspace onto the User JSON response. */
export interface PatchedUserDetails {
  /**
   * Can select weekends and outside working hours
   * Allows user to select pickup/delivery times on weekends and outside standard working hours.
   */
  can_select_extended_hours?: boolean;
  /** @maxLength 100 */
  city?: string;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  email_preferences?: UserEmailPreference[];
  readonly id?: number;
  /** User is company? */
  is_company?: boolean;
  readonly is_email_verified?: boolean;
  /**
   * Staff status
   * Designates whether the user can log into this admin site.
   */
  readonly is_staff?: boolean;
  /** User is vat payer? */
  is_vat_payer?: boolean;
  /**
   * User name
   * @maxLength 255
   */
  name?: string;
  /** @maxLength 128 */
  phone?: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** Language */
  preferred_language?: PreferredLanguageEnum | BlankEnum;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  timezone?: string | null;
  /** @maxLength 150 */
  vat_number?: string;
}

export interface PatchedWorkspace {
  /** @maxLength 100 */
  city?: string;
  /** Swida company ID */
  readonly company_id?: number | null;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum;
  /** @format date-time */
  readonly created_at?: string;
  readonly current_user_can_manage?: string;
  readonly current_user_is_creator?: string;
  readonly current_user_permissions?: string;
  readonly current_user_role?: string;
  readonly has_admin?: string;
  readonly has_pending_verification?: string;
  readonly id?: number;
  /** Is company? */
  is_company?: boolean;
  /** Is VAT payer? */
  is_vat_payer?: boolean;
  readonly is_verified?: boolean;
  readonly member_count?: string;
  /** @maxLength 255 */
  name?: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  /** @format date-time */
  readonly updated_at?: string | null;
  /** @maxLength 150 */
  vat_number?: string;
  /** @format date-time */
  readonly verified_at?: string | null;
  readonly workspace_type?: WorkspaceTypeEnum;
}

/**
 * * `INVOICE` - invoice
 * * `GATEWAY` - payment gateway
 */
export enum PaymentMethodEnum {
  INVOICE = "INVOICE",
  GATEWAY = "GATEWAY",
}

/**
 * * `en` - English
 * * `de` - German
 */
export enum PreferredLanguageEnum {
  En = "en",
  De = "de",
}

/** Adds nested create feature */
export interface PriceOption {
  category?: TransportCategory;
  delivery_datetime: Record<string, string>;
  readonly id: number;
  pickup_datetime: Record<string, string>;
  readonly pricing: Pricing;
  /**
   * Pricer ID
   * @min 0
   * @max 2147483647
   */
  result_id?: number | null;
  special_requirements_prices?: Record<string, any>;
}

export interface Pricing {
  /**
   * €
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  base_price: string;
  /**
   * €
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  cost_price: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly final_price: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly final_price_with_vat: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly total_discounts: string;
}

export type PricingValidateWaypointsCreateError = Record<string, any>;

export interface PricingValidation {
  /** Deprecated, will be removed in django-rest-framework-gis 1.0 */
  delivery: Waypoint;
  /** Deprecated, will be removed in django-rest-framework-gis 1.0 */
  pickup: Waypoint;
  /**
   * * `VAN` - VAN
   * * `SMALL_LORRY` - SMALL_LORRY
   * * `BIG_LORRY` - BIG_LORRY
   * * `LKW` - LKW
   */
  vehicle_type: VehicleTypeEnum;
}

/** Adds nested create feature */
export interface QuoteByHash {
  readonly billing_info: Record<string, any>;
  contact?: number | null;
  /** @format date-time */
  readonly created_at: string;
  created_by_manager?: boolean;
  default_price_option?: number | null;
  discount_usage: DiscountUsage[];
  /**
   * km
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  distance?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  duration?: string | null;
  /** @format date-time */
  expiration_time?: string | null;
  /** Full truck load */
  ftl?: boolean;
  readonly goods: Good[];
  /**
   * Hash key
   * @maxLength 64
   */
  hash?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  insurance_limit?: string | null;
  is_magic_link_visited?: boolean;
  /**
   * Result of the load fitting calculation from the Pricer API.
   *
   * * `FITS` - Fits
   * * `WEIGHT_EXCEEDED` - Weight Exceeded
   * * `LENGTH_EXCEEDED` - Length Exceeded
   * * `WIDTH_EXCEEDED` - Width Exceeded
   * * `HEIGHT_EXCEEDED` - Height Exceeded
   * * `LENGTH_MISSING` - Length Missing
   * * `WIDTH_MISSING` - Width Missing
   * * `HEIGHT_MISSING` - Height Missing
   * * `WEIGHT_MISSING` - Weight Missing
   * * `GOODS_MISSING` - Goods Missing
   * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
   * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
   * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
   * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
   * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
   * * `UNKNOWN` - Unknown Status
   */
  loading_status?: LoadingStatusEnum | BlankEnum | NullEnum | null;
  /** Operator */
  manager_account?: number | null;
  /** Notes */
  note?: string;
  notify_on_app_launch?: boolean;
  /** @format date-time */
  paid_datetime?: string | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  polyline?: string | null;
  /** @format date-time */
  price_option_set_time?: string | null;
  readonly price_options: PriceOption[];
  /** Custom quote */
  quote_custom?: boolean;
  readonly selected_price_option: PriceOption;
  special_requirements?: SpecialRequirements;
  /**
   * * `DRAFT` - Draft
   * * `PRICEABLE` - Priceable
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `WITH_ORDER` - With Order
   */
  state?: StateEnum;
  /** @format date-time */
  readonly updated_at: string | null;
  /** Full user serializer with name field - your original UserSerializer */
  user?: User;
  utm_parameters?: Utm;
  /** @format uuid */
  uuid?: string;
  vehicle_type?: VehicleTypeEnum | BlankEnum;
  waypoints?: Waypoint[];
}

/** Base quote serializer without user field */
export interface QuoteByID {
  /** Billing information */
  billing_info?: number | null;
  contact?: Contact;
  /** @format date-time */
  readonly created_at: string;
  created_by_manager?: boolean;
  default_price_option?: number | null;
  /**
   * km
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  distance?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  duration?: string | null;
  /** @format date-time */
  expiration_time?: string | null;
  /** Full truck load */
  ftl?: boolean;
  goods?: Good[];
  readonly id: number;
  is_magic_link_visited?: boolean;
  /**
   * Result of the load fitting calculation from the Pricer API.
   *
   * * `FITS` - Fits
   * * `WEIGHT_EXCEEDED` - Weight Exceeded
   * * `LENGTH_EXCEEDED` - Length Exceeded
   * * `WIDTH_EXCEEDED` - Width Exceeded
   * * `HEIGHT_EXCEEDED` - Height Exceeded
   * * `LENGTH_MISSING` - Length Missing
   * * `WIDTH_MISSING` - Width Missing
   * * `HEIGHT_MISSING` - Height Missing
   * * `WEIGHT_MISSING` - Weight Missing
   * * `GOODS_MISSING` - Goods Missing
   * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
   * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
   * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
   * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
   * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
   * * `UNKNOWN` - Unknown Status
   */
  loading_status?: LoadingStatusEnum | BlankEnum | NullEnum | null;
  /** Operator */
  manager_account?: number | null;
  /** Notes */
  note?: string;
  notify_on_app_launch?: boolean;
  polyline?: string | null;
  /** @format date-time */
  price_option_set_time?: string | null;
  /** Custom quote */
  quote_custom?: boolean;
  selected_price_option?: number | null;
  special_requirements: SpecialRequirements;
  /**
   * * `DRAFT` - Draft
   * * `PRICEABLE` - Priceable
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `WITH_ORDER` - With Order
   */
  state?: StateEnum;
  /** @format date-time */
  readonly updated_at: string | null;
  user?: number | null;
  utm_parameters?: Utm;
  /** @format uuid */
  uuid?: string;
  vehicle_type?: VehicleTypeEnum | BlankEnum;
  waypoints?: Waypoint[];
}

/** Quote serializer for creation with user create serializer (no name required) */
export interface QuoteCreateByID {
  /** Billing information */
  billing_info?: number | null;
  contact?: Contact;
  /** @format date-time */
  readonly created_at: string;
  created_by_manager?: boolean;
  default_price_option?: number | null;
  /**
   * km
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  distance?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  duration?: string | null;
  /** @format date-time */
  expiration_time?: string | null;
  /** Full truck load */
  ftl?: boolean;
  goods?: Good[];
  readonly id: number;
  is_magic_link_visited?: boolean;
  /**
   * Result of the load fitting calculation from the Pricer API.
   *
   * * `FITS` - Fits
   * * `WEIGHT_EXCEEDED` - Weight Exceeded
   * * `LENGTH_EXCEEDED` - Length Exceeded
   * * `WIDTH_EXCEEDED` - Width Exceeded
   * * `HEIGHT_EXCEEDED` - Height Exceeded
   * * `LENGTH_MISSING` - Length Missing
   * * `WIDTH_MISSING` - Width Missing
   * * `HEIGHT_MISSING` - Height Missing
   * * `WEIGHT_MISSING` - Weight Missing
   * * `GOODS_MISSING` - Goods Missing
   * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
   * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
   * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
   * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
   * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
   * * `UNKNOWN` - Unknown Status
   */
  loading_status?: LoadingStatusEnum | BlankEnum | NullEnum | null;
  /** Operator */
  manager_account?: number | null;
  /** Notes */
  note?: string;
  notify_on_app_launch?: boolean;
  polyline?: string | null;
  /** @format date-time */
  price_option_set_time?: string | null;
  /** Custom quote */
  quote_custom?: boolean;
  selected_price_option?: number | null;
  special_requirements: SpecialRequirements;
  /**
   * * `DRAFT` - Draft
   * * `PRICEABLE` - Priceable
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `WITH_ORDER` - With Order
   */
  state?: StateEnum;
  /** @format date-time */
  readonly updated_at: string | null;
  /** Minimal user serializer for quote creation - no name field */
  user?: UserCreateMinimal;
  utm_parameters?: Utm;
  /** @format uuid */
  uuid?: string;
  vehicle_type?: VehicleTypeEnum | BlankEnum;
  waypoints?: Waypoint[];
}

/** Adds nested create feature */
export interface QuoteWithOrder {
  readonly billing_info: Record<string, any>;
  readonly contact: Contact;
  /**
   * €
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  readonly cost_price: string | null;
  /** @format date-time */
  readonly created_at: string;
  readonly created_by_manager: boolean;
  readonly default_price_option: number | null;
  readonly discount_usage: DiscountUsage[];
  /**
   * km
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  readonly distance: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly duration: string | null;
  /** @format date-time */
  readonly expiration_time: string | null;
  /** Full truck load */
  readonly ftl: boolean;
  readonly goods: Good[];
  /**
   * Hash key
   * @maxLength 64
   */
  readonly hash: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly insurance_limit: string | null;
  readonly is_magic_link_visited: boolean;
  /**
   * Result of the load fitting calculation from the Pricer API.
   *
   * * `FITS` - Fits
   * * `WEIGHT_EXCEEDED` - Weight Exceeded
   * * `LENGTH_EXCEEDED` - Length Exceeded
   * * `WIDTH_EXCEEDED` - Width Exceeded
   * * `HEIGHT_EXCEEDED` - Height Exceeded
   * * `LENGTH_MISSING` - Length Missing
   * * `WIDTH_MISSING` - Width Missing
   * * `HEIGHT_MISSING` - Height Missing
   * * `WEIGHT_MISSING` - Weight Missing
   * * `GOODS_MISSING` - Goods Missing
   * * `FLOOR_SPACE_EXCEEDED` - Floor Space Exceeded
   * * `VEHICLE_LENGTH_MISSING` - Vehicle Length Missing
   * * `VEHICLE_WIDTH_MISSING` - Vehicle Width Missing
   * * `VEHICLE_HEIGHT_MISSING` - Vehicle Height Missing
   * * `VEHICLE_WEIGHT_MISSING` - Vehicle Weight Missing
   * * `UNKNOWN` - Unknown Status
   */
  readonly loading_status: LoadingStatusEnum | BlankEnum | NullEnum | null;
  readonly manager_account: User;
  /** Notes */
  readonly note: string;
  readonly notify_on_app_launch: boolean;
  readonly order: Order;
  /** @format date-time */
  readonly paid_datetime: string | null;
  readonly payment_method: PaymentMethodEnum | BlankEnum;
  readonly polyline: string | null;
  /**
   * €
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,2})?$
   */
  readonly price: string | null;
  /** @format date-time */
  readonly price_option_set_time: string | null;
  /** Custom quote */
  readonly quote_custom: boolean;
  readonly selected_price_option: PriceOption;
  readonly special_requirements: SpecialRequirements;
  readonly state: StateEnum;
  /** @format date-time */
  readonly updated_at: string | null;
  readonly user: User;
  readonly utm_parameters: number | null;
  readonly vehicle_type: VehicleTypeEnum | BlankEnum;
  readonly waypoints: Waypoint[];
  /** Workspace the quote was created under. Determines which workspace's Orders tab the resulting order appears in. */
  readonly workspace: number | null;
}

export type QuotesByHashCofaceTaskCreateError = Record<string, any>;

export type QuotesByHashConfirmCreateError = Record<string, any>;

export type QuotesByHashUpdateBillingCreatePayload = Record<string, any>;

export type QuotesByIdRouteDetailsCreateError = Record<string, any>;

export type QuotesByIdUpdateWaypointCreateError = Record<string, any>;

export interface Register {
  password1: string;
  password2: string;
  city?: string;
  company_name?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CD` - Congo (the Democratic Republic of the)
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `VA` - Holy See
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Nauru
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine, State of
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena, Ascension and Tristan da Cunha
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia and the South Sandwich Islands
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country?: CountryEnum;
  /** @format email */
  email: string;
  is_company: boolean;
  is_vat_payer?: boolean;
  name: string;
  phone?: string;
  postcode?: string;
  street?: string;
  street_number?: string;
  timezone?: string;
  /**
   * @minLength 1
   * @maxLength 0
   */
  username?: string;
  vat_number?: string;
}

export interface ResendEmailVerification {
  /** @format email */
  email: string;
}

export interface RestAuthDetail {
  readonly detail: string;
}

export interface RouteDetailsRequest {
  destination: Location;
  origin: Location;
  vehicle_type?: VehicleTypeEnum | BlankEnum;
}

export interface RouteDetailsResponse {
  /** @format double */
  distance: number;
  polyline: string;
}

/**
 * Payload posted by Swida when sales forward a verification request to
 * the admin of the IC workspace already verified for ``company_id``.
 */
export interface RouteToAdminWebhook {
  company_id: number;
  swida_request_id: number;
}

export interface SchemaRetrieveParams {
  format?: Format;
  lang?: Lang;
}

export enum SchemaRetrieveParams1Format {
  Json = "json",
  Yaml = "yaml",
}

export enum SchemaRetrieveParams1Lang {
  De = "de",
  En = "en",
}

export interface SpecialRequirements {
  /** a treaty governing transport of hazardous materials */
  adr?: boolean;
  /**
   * Driver assisted loading
   * Service where the driver actively assists in the loading of goods onto the vehicle.
   */
  assisted_loading?: boolean;
  /**
   * Driver assisted unloading
   * Service where the driver actively assists in the unloading of goods onto the vehicle.
   */
  assisted_unloading?: boolean;
  /**
   * Extended vehicle loading area
   * Loading area with extended length or height.
   */
  extended_loading_area?: boolean;
  /** refrigerator truck */
  frigo?: boolean;
  id?: number;
  tail_lift?: boolean;
  /** If there is a necessary downtime of the vehicle due to longer loading or unloading of goods. */
  vehicle_downtime?: boolean;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  vehicle_downtime_time?: number | null;
}

/**
 * * `DRAFT` - Draft
 * * `PRICEABLE` - Priceable
 * * `CONFIRMED` - Confirmed
 * * `CANCELED` - Canceled
 * * `WITH_ORDER` - With Order
 */
export enum StateEnum {
  DRAFT = "DRAFT",
  PRICEABLE = "PRICEABLE",
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
  WITH_ORDER = "WITH_ORDER",
}

export interface TokenRefresh {
  readonly access: string;
  refresh: string;
}

export interface TokenVerify {
  token: string;
}

/** Adds nested create feature */
export interface Transport {
  /** @format date-time */
  readonly created_at: string;
  /** Full user serializer with name field - your original UserSerializer */
  dispatcher?: User;
  location_updates?: TransportUpdate[];
  /** @maxLength 50 */
  plate_number?: string | null;
  /** @maxLength 50 */
  plate_number_trailer?: string;
  polyline?: string | null;
  /**
   * * `APPROVED` - approved
   * * `CANCELLED` - cancelled
   */
  status?: TransportStatusEnum;
  /** @format date-time */
  readonly updated_at: string | null;
  /** Vehicle type swida */
  vehicle_type?: TransportVehicleTypeEnum | BlankEnum;
}

export interface TransportCategory {
  description: string;
  /**
   * Duration of the timeframe in hours
   * @min -2147483648
   * @max 2147483647
   */
  duration_hours: number;
  readonly id: number;
  /**
   * Hours to move from the current time to start the timeframe
   * @min -2147483648
   * @max 2147483647
   */
  offset_hours: number;
  readonly title: string;
  readonly title_display: CategoryEnum;
}

/**
 * * `SEARCHING_FOR_THE_VEHICLE` - Searching for the vehicle
 * * `VEHICLE_FOUND` - Vehicle found
 * * `LOADED` - Loaded
 * * `ON_ROAD` - On Road
 * * `UNLOADED` - Unloaded
 */
export enum TransportProgressEnum {
  SEARCHING_FOR_THE_VEHICLE = "SEARCHING_FOR_THE_VEHICLE",
  VEHICLE_FOUND = "VEHICLE_FOUND",
  LOADED = "LOADED",
  ON_ROAD = "ON_ROAD",
  UNLOADED = "UNLOADED",
}

/**
 * * `APPROVED` - approved
 * * `CANCELLED` - cancelled
 */
export enum TransportStatusEnum {
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
}

/** Deprecated, will be removed in django-rest-framework-gis 1.0 */
export interface TransportUpdate {
  /** @format date-time */
  readonly created_at: string;
  /** @format date-time */
  datetime?: string | null;
  /**
   * km
   * @min 0
   * @max 32767
   */
  distance?: number | null;
  /**
   * * `SWIDA` - Swida
   * * `TRANSPORTLY` - Transportly
   */
  origin?: OriginEnum;
  point?: {
    /**
     * @maxItems 3
     * @minItems 2
     * @example [12.9721,77.5933]
     */
    coordinates?: number[];
    type?: TransportUpdateType;
  } | null;
  /**
   * * `ON_ROAD` - on road
   * * `PICKUP_ARRIVED` - pickup arrived
   * * `DELIVERY_ARRIVED` - delivery arrived
   * * `LOADED` - loaded
   * * `UNLOADED` - unloaded
   */
  status?: TransportUpdateStatusEnum;
  /** @format date-time */
  readonly updated_at: string | null;
}

/**
 * * `ON_ROAD` - on road
 * * `PICKUP_ARRIVED` - pickup arrived
 * * `DELIVERY_ARRIVED` - delivery arrived
 * * `LOADED` - loaded
 * * `UNLOADED` - unloaded
 */
export enum TransportUpdateStatusEnum {
  ON_ROAD = "ON_ROAD",
  PICKUP_ARRIVED = "PICKUP_ARRIVED",
  DELIVERY_ARRIVED = "DELIVERY_ARRIVED",
  LOADED = "LOADED",
  UNLOADED = "UNLOADED",
}

export enum TransportUpdateType {
  Point = "Point",
}

/**
 * * `CAR` - Pick-up
 * * `VAN` - Sprinter (up to 1.5t)
 * * `SMALL_LORRY` - Small lorry (up to 3.2t)
 * * `BIG_LORRY` - Big lorry (up to 7t)
 * * `LKW` - LKW
 */
export enum TransportVehicleTypeEnum {
  CAR = "CAR",
  VAN = "VAN",
  SMALL_LORRY = "SMALL_LORRY",
  BIG_LORRY = "BIG_LORRY",
  LKW = "LKW",
}

/**
 * * `pickup` - pickup
 * * `delivery` - delivery
 */
export enum TypeEnum {
  Pickup = "pickup",
  Delivery = "delivery",
}

export interface UpdatePayment {
  payment_method?: PaymentMethodEnum | BlankEnum | NullEnum | null;
}

/** Adds nested create feature */
export interface UpdateQuoteSpecialRequirements {
  special_requirements: SpecialRequirements;
}

/** Adds nested create feature */
export interface UpdateQuoteWaypoints {
  waypoints: UpdateWaypoint[];
}

/** Adds nested create feature */
export interface UpdateSelectedPriceOption {
  /** Adds nested create feature */
  selected_price_option: PriceOption;
}

export interface UpdateUserBillingType {
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CD` - Congo (the Democratic Republic of the)
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `VA` - Holy See
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Nauru
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine, State of
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena, Ascension and Tristan da Cunha
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia and the South Sandwich Islands
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country?: CountryEnum;
  /** User is company? */
  is_company?: boolean;
  /** User is vat payer? */
  is_vat_payer?: boolean;
}

export interface UpdateWaypoint {
  name?: string;
  street?: string;
  street_number?: string;
}

/** Full user serializer with name field - your original UserSerializer */
export interface User {
  /**
   * Can select weekends and outside working hours
   * Allows user to select pickup/delivery times on weekends and outside standard working hours.
   */
  can_select_extended_hours?: boolean;
  /** @maxLength 100 */
  city?: string;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum | NullEnum | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  /** User is company? */
  is_company?: boolean;
  /** User is vat payer? */
  is_vat_payer?: boolean;
  /**
   * User name
   * @maxLength 255
   */
  name: string;
  /** @maxLength 128 */
  phone?: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** Language */
  preferred_language?: PreferredLanguageEnum | BlankEnum;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  timezone?: string;
  /** @maxLength 150 */
  vat_number?: string;
}

/** Minimal user serializer for quote creation - no name field */
export interface UserCreateMinimal {
  /**
   * Can select weekends and outside working hours
   * Allows user to select pickup/delivery times on weekends and outside standard working hours.
   */
  can_select_extended_hours?: boolean;
  /** @maxLength 100 */
  city?: string;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum | NullEnum | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  /** User is company? */
  is_company?: boolean;
  /** User is vat payer? */
  is_vat_payer?: boolean;
  /** @maxLength 128 */
  phone?: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** Language */
  preferred_language?: PreferredLanguageEnum | BlankEnum;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  timezone?: string;
  /** @maxLength 150 */
  vat_number?: string;
}

/** Overlays company fields from the active workspace onto the User JSON response. */
export interface UserDetails {
  /**
   * Can select weekends and outside working hours
   * Allows user to select pickup/delivery times on weekends and outside standard working hours.
   */
  can_select_extended_hours?: boolean;
  /** @maxLength 100 */
  city?: string;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  email_preferences?: UserEmailPreference[];
  readonly id: number;
  /** User is company? */
  is_company?: boolean;
  readonly is_email_verified: boolean;
  /**
   * Staff status
   * Designates whether the user can log into this admin site.
   */
  readonly is_staff: boolean;
  /** User is vat payer? */
  is_vat_payer?: boolean;
  /**
   * User name
   * @maxLength 255
   */
  name: string;
  /** @maxLength 128 */
  phone?: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** Language */
  preferred_language?: PreferredLanguageEnum | BlankEnum;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  timezone?: string | null;
  /** @maxLength 150 */
  vat_number?: string;
}

/** Adds nested create feature */
export interface UserEmailPreference {
  /**
   * Moves `UniqueValidator`'s from the validation stage to the save stage.
   * It solves the problem with nested validation for unique fields on update.
   *
   * If you want more details, you can read related issues and articles:
   * https://github.com/beda-software/drf-writable-nested/issues/1
   * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
   *
   * Example of usage:
   * ```
   *     class Child(models.Model):
   *     field = models.CharField(unique=True)
   *
   *
   * class Parent(models.Model):
   *     child = models.ForeignKey('Child')
   *
   *
   * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
   *     class Meta:
   *         model = Child
   *
   *
   * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
   *     child = ChildSerializer()
   *
   *     class Meta:
   *         model = Parent
   * ```
   *
   * Note: `UniqueFieldsMixin` must be applied only on the serializer
   * which has unique fields.
   *
   * Note: When you are using both mixins
   * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
   * you should put `UniqueFieldsMixin` ahead.
   */
  group?: EmailPreferenceGroup;
  readonly id: number;
  is_enabled?: boolean;
}

export interface Utm {
  /** @maxLength 255 */
  utm_campaign?: string | null;
  /** @maxLength 255 */
  utm_content?: string | null;
  /** @maxLength 255 */
  utm_medium?: string | null;
  /** @maxLength 255 */
  utm_source?: string | null;
}

/**
 * * `VAN` - VAN
 * * `SMALL_LORRY` - SMALL_LORRY
 * * `BIG_LORRY` - BIG_LORRY
 * * `LKW` - LKW
 */
export enum VehicleTypeEnum {
  VAN = "VAN",
  SMALL_LORRY = "SMALL_LORRY",
  BIG_LORRY = "BIG_LORRY",
  LKW = "LKW",
}

/**
 * Payload posted by Swida when a Directory staff resolves a workspace
 * verification request. ``company_id`` is the Swida company that should
 * be linked to the workspace on approval; absent on rejection.
 *
 * ``company_name`` is the matched Swida company's name on approval (the
 * workspace is renamed to it) and ``multi_company_vat`` says whether the
 * VAT is shared by several Swida companies at resolution time — then the
 * other drafts with that VAT may belong to a different company and are
 * left alone. Both default so an older Swida can keep posting without them.
 */
export interface VerificationResolvedWebhook {
  approved: boolean;
  company_id?: number | null;
  /** @default "" */
  company_name?: string;
  /** @default false */
  multi_company_vat?: boolean;
  /** @default "" */
  note?: string;
  swida_request_id: number;
}

export interface VerifyEmail {
  key: string;
}

/** Deprecated, will be removed in django-rest-framework-gis 1.0 */
export interface Waypoint {
  /** @maxLength 50 */
  city?: string;
  country?: CountryEnum | BlankEnum;
  /** @format date-time */
  readonly created_at: string;
  /** @format date-time */
  datetime?: string | null;
  readonly id: number;
  /**
   * Full name / company
   * @maxLength 100
   */
  name?: string;
  /** GPS coordinates */
  point?: {
    /**
     * @maxItems 3
     * @minItems 2
     * @example [12.9721,77.5933]
     */
    coordinates?: number[];
    type?: WaypointType;
  } | null;
  /** @maxLength 30 */
  postcode?: string;
  /**
   * @min 0
   * @max 32767
   */
  sequence?: number | null;
  /** @maxLength 200 */
  street?: string;
  /** @maxLength 200 */
  street_number?: string;
  type?: TypeEnum | BlankEnum;
  /** @format date-time */
  readonly updated_at: string | null;
}

export enum WaypointType {
  Point = "Point",
}

export interface Workspace {
  /** @maxLength 100 */
  city?: string;
  /** Swida company ID */
  readonly company_id: number | null;
  /** @maxLength 100 */
  company_name?: string;
  country?: CountryEnum | BlankEnum;
  /** @format date-time */
  readonly created_at: string;
  readonly current_user_can_manage: string;
  readonly current_user_is_creator: string;
  readonly current_user_permissions: string;
  readonly current_user_role: string;
  readonly has_admin: string;
  readonly has_pending_verification: string;
  readonly id: number;
  /** Is company? */
  is_company?: boolean;
  /** Is VAT payer? */
  is_vat_payer?: boolean;
  readonly is_verified: boolean;
  readonly member_count: string;
  /** @maxLength 255 */
  name: string;
  /**
   * Post code
   * @maxLength 20
   */
  postcode?: string;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 100 */
  street_number?: string;
  /** @format date-time */
  readonly updated_at: string | null;
  /** @maxLength 150 */
  vat_number?: string;
  /** @format date-time */
  readonly verified_at: string | null;
  readonly workspace_type: WorkspaceTypeEnum;
}

export interface WorkspaceEmailPreference {
  readonly description: string;
  is_enabled: boolean;
  key: string;
  readonly name: string;
}

export interface WorkspaceNotificationRecipient {
  /**
   * @format email
   * @maxLength 254
   */
  email: string;
  /**
   * @minLength 2
   * @maxLength 255
   */
  name: string;
}

/**
 * The caller's Transport Updates switch and additional recipients in one
 * workspace (``GET``/``PUT /api/workspaces/{id}/notification-settings/``).
 */
export interface WorkspaceNotificationSettings {
  email_preferences: WorkspaceEmailPreference[];
  notification_recipients: WorkspaceNotificationRecipient[];
  readonly workspace: number;
}

/**
 * * `personal` - Personal
 * * `company` - Company
 */
export enum WorkspaceTypeEnum {
  Personal = "personal",
  Company = "company",
}

export namespace CheckEmailVerification {
  /**
   * @description API endpoint to check if an email is verified.
   * @tags email-verification
   * @name AuthCheckEmailVerificationRetrieve
   * @request GET:/api/auth/check-email-verification/
   * @secure
   * @response `200` `void` Verification status
   * @response `400` `void` Invalid email or request format
   */
  export namespace AuthCheckEmailVerificationRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Email address */
      email: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace LandingStatus {
  /**
   * @description Sign-in state for the Swida landing's header, read cross-site with `credentials: "include"`. Authenticates by the `ic_landing_session` cookie alone, never by a JWT. Without a valid cookie, or for an inactive account, it answers `{"logged_in": false}` with 200. Signed in, `company_name` is what IC's header shows: the active company's name (its VAT ID while it is an unverified VAT payer's draft), or the e-mail for the personal workspace.
   * @tags auth
   * @name AuthLandingStatusRetrieve
   * @request GET:/api/auth/landing-status/
   * @secure
   * @response `200` `LandingStatus`
   */
  export namespace AuthLandingStatusRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LandingStatus;
  }
}

export namespace Login {
  /**
   * @description Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework Accept the following POST parameters: username, password Return the REST Framework Token Object's key.
   * @tags auth
   * @name AuthLoginCreate
   * @request POST:/api/auth/login/
   * @secure
   * @response `200` `JWT`
   */
  export namespace AuthLoginCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomLogin;
    export type RequestHeaders = {};
    export type ResponseBody = JWT;
  }
}

export namespace Logout {
  /**
   * @description Calls Django logout method and delete the Token object assigned to the current User object. Accepts/Returns nothing.
   * @tags auth
   * @name AuthLogoutCreate
   * @request POST:/api/auth/logout/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthLogoutCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }
}

export namespace Password {
  /**
   * @description Calls Django Auth SetPasswordForm save method. Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
   * @tags auth
   * @name AuthPasswordChangeCreate
   * @request POST:/api/auth/password/change/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthPasswordChangeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PasswordChange;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Calls Django Auth PasswordResetForm save method. Accepts the following POST parameters: email Returns the success/fail message.
   * @tags auth
   * @name AuthPasswordResetCreate
   * @request POST:/api/auth/password/reset/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthPasswordResetCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PasswordReset;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Password reset e-mail link is confirmed, therefore this resets the user's password. Accepts the following POST parameters: token, uid, new_password1, new_password2 Returns the success/fail message.
   * @tags auth
   * @name AuthPasswordResetConfirmCreate
   * @request POST:/api/auth/password/reset/confirm/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthPasswordResetConfirmCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PasswordResetConfirm;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }
}

export namespace Register {
  /**
   * @description Registers a new user. Accepts the following POST parameters: username, email, password1, password2.
   * @tags auth
   * @name AuthRegisterCreate
   * @request POST:/api/auth/register/
   * @secure
   * @response `201` `Register`
   */
  export namespace AuthRegisterCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Register;
    export type RequestHeaders = {};
    export type ResponseBody = Register;
  }

  /**
   * @description Resends another email to an unverified email. Accepts the following POST parameter: email.
   * @tags auth
   * @name AuthRegisterResendEmailCreate
   * @request POST:/api/auth/register/resend-email/
   * @secure
   * @response `201` `RestAuthDetail`
   */
  export namespace AuthRegisterResendEmailCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResendEmailVerification;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Verifies the email associated with the provided key. Accepts the following POST parameter: key.
   * @tags auth
   * @name AuthRegisterVerifyEmailCreate
   * @request POST:/api/auth/register/verify-email/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthRegisterVerifyEmailCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VerifyEmail;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }
}

export namespace Token {
  /**
   * @description Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
   * @tags auth
   * @name AuthTokenRefreshCreate
   * @request POST:/api/auth/token/refresh/
   * @response `200` `TokenRefresh`
   */
  export namespace AuthTokenRefreshCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TokenRefresh;
    export type RequestHeaders = {};
    export type ResponseBody = TokenRefresh;
  }

  /**
   * @description Takes a token and indicates if it is valid.  This view provides no information about a token's fitness for a particular use.
   * @tags auth
   * @name AuthTokenVerifyCreate
   * @request POST:/api/auth/token/verify/
   * @response `200` `TokenVerify`
   */
  export namespace AuthTokenVerifyCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TokenVerify;
    export type RequestHeaders = {};
    export type ResponseBody = TokenVerify;
  }

  /**
   * @description Public endpoints used by the invite landing page. ``GET /api/invitations/{token}/`` — read-only invitation view for the unauthenticated landing page (returns workspace name, invited_by name, status, and whether a password is required). ``POST /api/invitations/{token}/accept/`` — accept and issue JWT cookies identical to a fresh login.
   * @tags invitations
   * @name InvitationsRetrieve
   * @request GET:/api/invitations/{token}/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace InvitationsRetrieve {
    export type RequestParams = {
      /** @pattern ^[A-Za-z0-9_\-]+$ */
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Public endpoints used by the invite landing page. ``GET /api/invitations/{token}/`` — read-only invitation view for the unauthenticated landing page (returns workspace name, invited_by name, status, and whether a password is required). ``POST /api/invitations/{token}/accept/`` — accept and issue JWT cookies identical to a fresh login.
   * @tags invitations
   * @name InvitationsAcceptCreate
   * @request POST:/api/invitations/{token}/accept/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace InvitationsAcceptCreate {
    export type RequestParams = {
      /** @pattern ^[A-Za-z0-9_\-]+$ */
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace User {
  /**
   * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
   * @tags auth
   * @name AuthUserRetrieve
   * @request GET:/api/auth/user/
   * @secure
   * @response `200` `UserDetails`
   */
  export namespace AuthUserRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserDetails;
  }

  /**
   * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
   * @tags auth
   * @name AuthUserUpdate
   * @request PUT:/api/auth/user/
   * @secure
   * @response `200` `UserDetails`
   */
  export namespace AuthUserUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UserDetails;
    export type RequestHeaders = {};
    export type ResponseBody = UserDetails;
  }

  /**
   * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
   * @tags auth
   * @name AuthUserPartialUpdate
   * @request PATCH:/api/auth/user/
   * @secure
   * @response `200` `UserDetails`
   */
  export namespace AuthUserPartialUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PatchedUserDetails;
    export type RequestHeaders = {};
    export type ResponseBody = UserDetails;
  }
}

export namespace GetDefaultPriceSettings {
  /**
   * @description API endpoint to retrieve default price settings.
   * @tags default-price-settings
   * @name DefaultPriceSettingsGetDefaultPriceSettingsRetrieve
   * @request GET:/api/default-price-settings/get-default-price-settings/
   * @secure
   * @response `200` `DefaultPriceSettings`
   */
  export namespace DefaultPriceSettingsGetDefaultPriceSettingsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DefaultPriceSettings;
  }
}

export namespace Apply {
  /**
   * @description API endpoint to apply a discount code to a quote.
   * @tags discounts
   * @name DiscountsApplyCreate
   * @request POST:/api/discounts/apply/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace DiscountsApplyCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApplyDiscount;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }
}

export namespace Subscribe {
  /**
   * @description Subscribe an e-mail to the MailerLite newsletter group from the site footer.
   * @tags newsletter
   * @name NewsletterSubscribeCreate
   * @request POST:/api/newsletter/subscribe/
   * @secure
   * @response `200` `NewsletterSubscribe`
   */
  export namespace NewsletterSubscribeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = NewsletterSubscribe;
    export type RequestHeaders = {};
    export type ResponseBody = NewsletterSubscribe;
  }
}

export namespace Id {
  /**
   * @description Mark a single notification as read.
   * @tags notifications
   * @name NotificationsMarkReadCreate
   * @request POST:/api/notifications/{id}/mark-read/
   * @secure
   * @response `200` `Notification`
   */
  export namespace NotificationsMarkReadCreate {
    export type RequestParams = {
      /** A unique integer value identifying this Notification. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Notification;
    export type RequestHeaders = {};
    export type ResponseBody = Notification;
  }

  /**
   * @description API endpoints that allow users to be viewed or edited.
   * @tags users
   * @name UsersRetrieve
   * @request GET:/api/users/{id}/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }

  /**
   * @description API endpoints that allow users to be viewed or edited.
   * @tags users
   * @name UsersUpdate
   * @request PUT:/api/users/{id}/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = User;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }

  /**
   * @description API endpoints that allow users to be viewed or edited.
   * @tags users
   * @name UsersPartialUpdate
   * @request PATCH:/api/users/{id}/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedUser;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }

  /**
   * No description
   * @tags workspaces
   * @name WorkspacesRetrieve
   * @request GET:/api/workspaces/{id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspaces
   * @name WorkspacesUpdate
   * @request PUT:/api/workspaces/{id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesUpdate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspaces
   * @name WorkspacesPartialUpdate
   * @request PATCH:/api/workspaces/{id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesPartialUpdate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedWorkspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Delete a company workspace that the user created in error. Allowed only when the workspace is: * a COMPANY workspace (never a user's personal one) * unverified and not yet linked to a Swida company * has exactly one member (the acting admin) If the deleted workspace was the user's active one, we first flip their personal workspace back to active so they aren't stranded without a selected workspace.
   * @tags workspaces
   * @name WorkspacesDestroy
   * @request DELETE:/api/workspaces/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace WorkspacesDestroy {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description POST creates a new admin access request; GET returns the current state of the latest request for the authenticated user.
   * @tags workspaces
   * @name WorkspacesAdminAccessRequestRetrieve
   * @request GET:/api/workspaces/{id}/admin-access-request/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesAdminAccessRequestRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description POST creates a new admin access request; GET returns the current state of the latest request for the authenticated user.
   * @tags workspaces
   * @name WorkspacesAdminAccessRequestCreate
   * @request POST:/api/workspaces/{id}/admin-access-request/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesAdminAccessRequestCreate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Admin-only: list pending invitations or send a new one.
   * @tags workspaces
   * @name WorkspacesInvitationsRetrieve
   * @request GET:/api/workspaces/{id}/invitations/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesInvitationsRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Admin-only: list pending invitations or send a new one.
   * @tags workspaces
   * @name WorkspacesInvitationsCreate
   * @request POST:/api/workspaces/{id}/invitations/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesInvitationsCreate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Admin-only: revoke a pending invitation.
   * @tags workspaces
   * @name WorkspacesInvitationsDestroy
   * @request DELETE:/api/workspaces/{id}/invitations/{invitation_id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace WorkspacesInvitationsDestroy {
    export type RequestParams = {
      id: string;
      /** @pattern ^\d+$ */
      invitationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags workspaces
   * @name WorkspacesJoinRequestsRetrieve
   * @request GET:/api/workspaces/{id}/join-requests/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesJoinRequestsRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description List workspace members. Admins see every membership (full PII payload). Non-admins with ``can_access_company_details`` see only their own membership row — they're allowed onto the Company Details screen but must not be able to enumerate peers' emails, phones, or per-user permission flags. Anyone else gets 403.
   * @tags workspaces
   * @name WorkspacesMembersRetrieve
   * @request GET:/api/workspaces/{id}/members/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesMembersRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Admin-only: update a member's role and view permissions, or remove them. PATCH body: any subset of ``role`` and ``can_access_invoices/company_details/loyalty``. DELETE: removes the membership (cannot remove self). Neither may take away the workspace's last admin.
   * @tags workspaces
   * @name WorkspacesMembersPartialUpdate
   * @request PATCH:/api/workspaces/{id}/members/{user_id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesMembersPartialUpdate {
    export type RequestParams = {
      id: string;
      /** @pattern ^\d+$ */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedWorkspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Admin-only: update a member's role and view permissions, or remove them. PATCH body: any subset of ``role`` and ``can_access_invoices/company_details/loyalty``. DELETE: removes the membership (cannot remove self). Neither may take away the workspace's last admin.
   * @tags workspaces
   * @name WorkspacesMembersDestroy
   * @request DELETE:/api/workspaces/{id}/members/{user_id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace WorkspacesMembersDestroy {
    export type RequestParams = {
      id: string;
      /** @pattern ^\d+$ */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description The caller's own transport e-mail settings in this workspace. GET returns the Transport Updates switch and the additional recipients of the caller's membership; PUT replaces them and returns the stored result. Any member may use it, personal workspaces and drafts included. The workspace comes from the URL, never from the active workspace, so a stale tab saves into the company it shows; other members' settings are never read or written.
   * @tags workspaces
   * @name WorkspacesNotificationSettingsRetrieve
   * @request GET:/api/workspaces/{id}/notification-settings/
   * @secure
   * @response `200` `WorkspaceNotificationSettings`
   */
  export namespace WorkspacesNotificationSettingsRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceNotificationSettings;
  }

  /**
   * @description The caller's own transport e-mail settings in this workspace. GET returns the Transport Updates switch and the additional recipients of the caller's membership; PUT replaces them and returns the stored result. Any member may use it, personal workspaces and drafts included. The workspace comes from the URL, never from the active workspace, so a stale tab saves into the company it shows; other members' settings are never read or written.
   * @tags workspaces
   * @name WorkspacesNotificationSettingsUpdate
   * @request PUT:/api/workspaces/{id}/notification-settings/
   * @secure
   * @response `200` `WorkspaceNotificationSettings`
   */
  export namespace WorkspacesNotificationSettingsUpdate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = WorkspaceNotificationSettings;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceNotificationSettings;
  }

  /**
   * @description Request workspace verification. Body may include ``vat_number`` and ``company_name`` to top up a workspace that didn't have them before. A VAT payer needs only the VAT; a non-VAT payer needs the company name and full address on the workspace. Two response shapes: * ``201`` — a ``WorkspaceVerificationRequest`` was created and pushed to Swida for staff review. * ``202`` — a ``WorkspaceJoinRequest`` was created against an already-verified workspace with the same VAT (the user is asking to join an existing verified workspace instead of duplicating it); the original draft was auto-deleted when safe. Only for a VAT payer whose VAT belongs to a single Swida company; otherwise the request goes to Swida sales (201).
   * @tags workspaces
   * @name WorkspacesRequestVerificationCreate
   * @request POST:/api/workspaces/{id}/request-verification/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesRequestVerificationCreate {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description Return the most recent verification request (any status) for the workspace. Used by the frontend to show ``pending`` / ``rejected`` button state. ``{status: null}`` if no record exists yet.
   * @tags workspaces
   * @name WorkspacesVerificationRequestRetrieve
   * @request GET:/api/workspaces/{id}/verification-request/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesVerificationRequestRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspaces
   * @name WorkspacesVerificationRequestsRetrieve
   * @request GET:/api/workspaces/{id}/verification-requests/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesVerificationRequestsRetrieve {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace ClearAll {
  /**
   * @description Delete all of the user's notifications ("Clear all" button).
   * @tags notifications
   * @name NotificationsClearAllCreate
   * @request POST:/api/notifications/clear-all/
   * @secure
   * @response `200` `void` All notifications cleared.
   */
  export namespace NotificationsClearAllCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Notification;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace UnreadCount {
  /**
   * @description Number of unread notifications — drives the bell badge.
   * @tags notifications
   * @name NotificationsUnreadCountRetrieve
   * @request GET:/api/notifications/unread-count/
   * @secure
   * @response `200` `NotificationUnreadCount`
   */
  export namespace NotificationsUnreadCountRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationUnreadCount;
  }
}

export namespace Countries {
  /**
   * No description
   * @tags options
   * @name OptionsCountriesRetrieve
   * @request GET:/api/options/countries/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCountriesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }
}

export namespace Quote {
  /**
   * @description API endpoints that allow orders to be viewed or edited.
   * @tags orders
   * @name OrdersRetrieve
   * @request GET:/api/orders/{quote}/
   * @secure
   * @response `200` `Order`
   */
  export namespace OrdersRetrieve {
    export type RequestParams = {
      quote: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Order;
  }

  /**
   * @description API endpoints that allow orders to be viewed or edited.
   * @tags orders
   * @name OrdersUpdate
   * @request PUT:/api/orders/{quote}/
   * @secure
   * @response `200` `Order` Successfully updated the order.
   * @response `400` `void` Invalid input.
   * @response `404` `void` Order not found.
   */
  export namespace OrdersUpdate {
    export type RequestParams = {
      quote: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Order;
    export type RequestHeaders = {};
    export type ResponseBody = Order;
  }

  /**
   * @description API endpoints that allow orders to be viewed or edited.
   * @tags orders
   * @name OrdersPartialUpdate
   * @request PATCH:/api/orders/{quote}/
   * @secure
   * @response `200` `Order`
   */
  export namespace OrdersPartialUpdate {
    export type RequestParams = {
      quote: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedOrder;
    export type RequestHeaders = {};
    export type ResponseBody = Order;
  }
}

export namespace Quotes {
  /**
   * @description Partner-facing endpoint that creates a prefilled `/free-quote` deep link. Auth via `HasPartnerAPITokenPermission`; the matched `Partner` row is attached to `request.partner` so `utm_source` can be bound to identity. Body matches `POST /api/quotes-by-id/` plus optional top-level `utm_campaign` / `utm_medium` / `utm_content`. `utm_source` from the body is ignored — it is always `request.partner.slug`.
   * @tags partners
   * @name PartnersQuotesCreate
   * @request POST:/api/partners/quotes/
   * @response `201` `PartnerQuoteResponse`
   */
  export namespace PartnersQuotesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = QuoteCreateByID;
    export type RequestHeaders = {};
    export type ResponseBody = PartnerQuoteResponse;
  }
}

export namespace CheckoutSession {
  /**
   * No description
   * @tags payments
   * @name PaymentsCheckoutSessionCreate
   * @request POST:/api/payments/checkout-session/{hash}/
   * @secure
   * @response `200` `CheckoutResponse`
   */
  export namespace PaymentsCheckoutSessionCreate {
    export type RequestParams = {
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CheckoutResponse;
  }
}

export namespace ValidateWaypoints {
  /**
   * @description Makes call to pricer with data that is required to determine if addresses are allowed.
   * @tags pricing
   * @name PricingValidateWaypointsCreate
   * @request POST:/api/pricing/validate-waypoints/
   * @secure
   * @response `204` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace PricingValidateWaypointsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PricingValidation;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Hash {
  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashRetrieve
   * @request GET:/api/quotes-by-hash/{hash}/
   * @secure
   * @response `200` `QuoteByHash` Successfully retrieved quote.
   */
  export namespace QuotesByHashRetrieve {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashUpdate
   * @request PUT:/api/quotes-by-hash/{hash}/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = QuoteByHash;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashPartialUpdate
   * @request PATCH:/api/quotes-by-hash/{hash}/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashPartialUpdate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedQuoteByHash;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashAutofillCompanyCreate
   * @request POST:/api/quotes-by-hash/{hash}/autofill-company/
   * @secure
   * @response `200` `CofaceCompanyDataResponse`
   */
  export namespace QuotesByHashAutofillCompanyCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CofaceCompanyResponse;
    export type RequestHeaders = {};
    export type ResponseBody = CofaceCompanyDataResponse;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashCofaceTaskCreate
   * @request POST:/api/quotes-by-hash/{hash}/coface-task/
   * @secure
   * @response `200` `number`
   * @response `400` `Record<string,any>`
   */
  export namespace QuotesByHashCofaceTaskCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashConfirmCreate
   * @request POST:/api/quotes-by-hash/{hash}/confirm/
   * @secure
   * @response `200` `QuoteByHash`
   * @response `400` `Record<string,any>`
   */
  export namespace QuotesByHashConfirmCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description Mark quote's magic link as visited
   * @tags quotes-by-hash
   * @name QuotesByHashMarkMagicLinkVisitedCreate
   * @request POST:/api/quotes-by-hash/{hash}/mark-magic-link-visited/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace QuotesByHashMarkMagicLinkVisitedCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashUpdateBillingCreate
   * @request POST:/api/quotes-by-hash/{hash}/update-billing/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdateBillingCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = QuotesByHashUpdateBillingCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashUpdatePaymentCreate
   * @request POST:/api/quotes-by-hash/{hash}/update-payment/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdatePaymentCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdatePayment;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashUpdateQuoteUserTypeCreate
   * @request POST:/api/quotes-by-hash/{hash}/update-quote-user-type/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdateQuoteUserTypeCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateUserBillingType;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description Update unfilled fields in waypoints
   * @tags quotes-by-hash
   * @name QuotesByHashUpdateQuoteWaypointsCreate
   * @request POST:/api/quotes-by-hash/{hash}/update-quote-waypoints/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdateQuoteWaypointsCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateQuoteWaypoints;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashUpdateSelectedPriceOptionCreate
   * @request POST:/api/quotes-by-hash/{hash}/update-selected-price-option/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdateSelectedPriceOptionCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateSelectedPriceOption;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashUpdateSpecialRequirementsCreate
   * @request POST:/api/quotes-by-hash/{hash}/update-special-requirements/
   * @secure
   * @response `200` `QuoteByHash`
   */
  export namespace QuotesByHashUpdateSpecialRequirementsCreate {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateQuoteSpecialRequirements;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByHash;
  }

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   * @tags quotes-by-hash
   * @name QuotesByHashWithOrderRetrieve
   * @request GET:/api/quotes-by-hash/{hash}/with-order/
   * @secure
   * @response `200` `QuoteWithOrder`
   */
  export namespace QuotesByHashWithOrderRetrieve {
    export type RequestParams = {
      /** The Hash of the quote */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteWithOrder;
  }
}

export namespace Uuid {
  /**
   * @description Mixin that disables the list and destroy actions.
   * @tags quotes-by-id
   * @name QuotesByIdUpdate
   * @request PUT:/api/quotes-by-id/{uuid}/
   * @secure
   * @response `200` `QuoteByID`
   */
  export namespace QuotesByIdUpdate {
    export type RequestParams = {
      /** @format uuid */
      uuid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = QuoteByID;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByID;
  }

  /**
   * @description Mixin that disables the list and destroy actions.
   * @tags quotes-by-id
   * @name QuotesByIdPartialUpdate
   * @request PATCH:/api/quotes-by-id/{uuid}/
   * @secure
   * @response `200` `QuoteByID`
   */
  export namespace QuotesByIdPartialUpdate {
    export type RequestParams = {
      /** @format uuid */
      uuid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedQuoteByID;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByID;
  }

  /**
   * @description Retrieves detailed information about a route, including the best route and transit time
   * @tags quotes-by-id
   * @name QuotesByIdRouteDetailsCreate
   * @request POST:/api/quotes-by-id/{uuid}/route-details/
   * @secure
   * @response `200` `RouteDetailsResponse`
   * @response `400` `Record<string,any>`
   */
  export namespace QuotesByIdRouteDetailsCreate {
    export type RequestParams = {
      /** @format uuid */
      uuid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = RouteDetailsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = RouteDetailsResponse;
  }

  /**
   * @description Updates quote pricing (vehicle type, goods, special requirements) and returns calculated price
   * @tags quotes-by-id
   * @name QuotesByIdUpdatePricingPartialUpdate
   * @request PATCH:/api/quotes-by-id/{uuid}/update-pricing/
   * @secure
   * @response `200` `DefaultPriceResponse`
   */
  export namespace QuotesByIdUpdatePricingPartialUpdate {
    export type RequestParams = {
      /** @format uuid */
      uuid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedUpdateQuotePricing;
    export type RequestHeaders = {};
    export type ResponseBody = DefaultPriceResponse;
  }

  /**
   * @description Update quote's UTM parameters with provided data
   * @tags quotes-by-id
   * @name QuotesByIdUpdateUtmCreate
   * @request POST:/api/quotes-by-id/{uuid}/update-utm/
   * @secure
   * @response `200` `QuoteByID`
   */
  export namespace QuotesByIdUpdateUtmCreate {
    export type RequestParams = {
      /** @format uuid */
      uuid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Utm;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteByID;
  }

  /**
   * @description Update quote's waypoint with provided data
   * @tags quotes-by-id
   * @name QuotesByIdUpdateWaypointCreate
   * @request POST:/api/quotes-by-id/{uuid}/update-waypoint/
   * @secure
   * @response `200` `Waypoint`
   * @response `404` `Record<string,any>`
   */
  export namespace QuotesByIdUpdateWaypointCreate {
    export type RequestParams = {
      /** @format uuid */
      uuid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Waypoint;
    export type RequestHeaders = {};
    export type ResponseBody = Waypoint;
  }
}

export namespace Me {
  /**
   * @description API endpoints that allow users to be viewed or edited.
   * @tags users
   * @name UsersMeRetrieve
   * @request GET:/api/users/me/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersMeRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }
}

export namespace Swida {
  /**
   * @description Swida sales picked ``company_id`` for a pending verification and want the admin of that company's verified IC workspace to decide. Payload: ``{swida_request_id, company_id}``. Answers: * ``200 {"routed": true}`` — a join request was created for the workspace admin (or already existed for this Swida request); Swida marks the request as forwarded and waits for the admin's decision, which comes back via ``admin-decision``. * ``200 {"routed": false}`` — no verified workspace with an admin exists for that company; sales approve the request themselves. * ``404`` — IC has no pending verification request with that id. * ``409`` — the requester is already a member of that workspace.
   * @tags webhooks
   * @name WebhooksSwidaRouteToAdminCreate
   * @request POST:/api/webhooks/swida/route-to-admin/
   * @response `200` `RouteToAdminWebhook`
   */
  export namespace WebhooksSwidaRouteToAdminCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouteToAdminWebhook;
    export type RequestHeaders = {};
    export type ResponseBody = RouteToAdminWebhook;
  }

  /**
   * @description Swida has resolved a workspace verification request. Approve payload:  ``{swida_request_id, approved: True, company_id, company_name, multi_company_vat, note}`` Reject payload:   ``{swida_request_id, approved: False, note}`` On approval IC flips ``workspace.is_verified = True``, sets the Swida company linkage, renames the workspace to ``company_name`` and auto-promotes the requester to ADMIN. ``multi_company_vat`` keeps the VAT-based duplicate-draft cleanup away from drafts that may belong to a sibling company under the same VAT.
   * @tags webhooks
   * @name WebhooksSwidaVerificationResolvedCreate
   * @request POST:/api/webhooks/swida/verification-resolved/
   * @response `200` `VerificationResolvedWebhook`
   */
  export namespace WebhooksSwidaVerificationResolvedCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VerificationResolvedWebhook;
    export type RequestHeaders = {};
    export type ResponseBody = VerificationResolvedWebhook;
  }
}

export namespace Active {
  /**
   * No description
   * @tags workspaces
   * @name WorkspacesActiveRetrieve
   * @request GET:/api/workspaces/active/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesActiveRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace InvoicePdf {
  /**
   * @description Proxy endpoint to download/view invoice PDF from Swida.
   * @tags workspaces
   * @name WorkspacesInvoicePdfRetrieve
   * @request GET:/api/workspaces/invoice-pdf/{invoice_id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesInvoicePdfRetrieve {
    export type RequestParams = {
      /** @pattern ^\d+$ */
      invoiceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace Invoices {
  /**
   * @description Get invoices for the active workspace. Only available for verified workspaces with a company ID.
   * @tags workspaces
   * @name WorkspacesInvoicesRetrieve
   * @request GET:/api/workspaces/invoices/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesInvoicesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace JoinRequests {
  /**
   * No description
   * @tags workspaces
   * @name WorkspacesJoinRequestsResolveCreate
   * @request POST:/api/workspaces/join-requests/{request_id}/resolve/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesJoinRequestsResolveCreate {
    export type RequestParams = {
      /** @pattern ^\d+$ */
      requestId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace Loyalty {
  /**
   * @description The company's loyalty point balance + program rules (drives the badge, the <20-points greyed-out catalogue gate, and the rules section).
   * @tags workspaces
   * @name WorkspacesLoyaltyBalanceRetrieve
   * @request GET:/api/workspaces/loyalty/balance/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesLoyaltyBalanceRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description CLIENT gadget catalogue from Swida for the active workspace's company.
   * @tags workspaces
   * @name WorkspacesLoyaltyGadgetsRetrieve
   * @request GET:/api/workspaces/loyalty/gadgets/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesLoyaltyGadgetsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description GET: the company's merch-order history. POST: place a merch order (redeem points). ``company_id`` is injected from the verified workspace — never trusted from the client body.
   * @tags workspaces
   * @name WorkspacesLoyaltyOrdersRetrieve
   * @request GET:/api/workspaces/loyalty/orders/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesLoyaltyOrdersRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * @description GET: the company's merch-order history. POST: place a merch order (redeem points). ``company_id`` is injected from the verified workspace — never trusted from the client body.
   * @tags workspaces
   * @name WorkspacesLoyaltyOrdersCreate
   * @request POST:/api/workspaces/loyalty/orders/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesLoyaltyOrdersCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace MyJoinRequests {
  /**
   * No description
   * @tags workspaces
   * @name WorkspacesMyJoinRequestsRetrieve
   * @request GET:/api/workspaces/my-join-requests/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesMyJoinRequestsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace Orders {
  /**
   * @description Get orders for the active workspace. Verified carriers (with company_id): orders from the Swida API only. Unverified carriers: orders from the IC database only.
   * @tags workspaces
   * @name WorkspacesOrdersRetrieve
   * @request GET:/api/workspaces/orders/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesOrdersRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace Switch {
  /**
   * No description
   * @tags workspaces
   * @name WorkspacesSwitchCreate
   * @request POST:/api/workspaces/switch/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesSwitchCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

export namespace VerificationRequests {
  /**
   * No description
   * @tags workspaces
   * @name WorkspacesVerificationRequestsResolveCreate
   * @request POST:/api/workspaces/verification-requests/{request_id}/resolve/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacesVerificationRequestsResolveCreate {
    export type RequestParams = {
      /** @pattern ^\d+$ */
      requestId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title instacarrier API
 * @version 1.0.0
 *
 * Documentation of API endpoints of instacarrier
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags email-domains-blacklist
   * @name EmailDomainsBlacklistList
   * @request GET:/api/email-domains-blacklist/
   * @secure
   * @response `200` `(BlacklistedEmailDomain)[]`
   */
  emailDomainsBlacklistList = (params: RequestParams = {}) =>
    this.request<BlacklistedEmailDomain[], any>({
      path: `/api/email-domains-blacklist/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description API endpoint that allows feedbacks to be created.
   *
   * @tags feedbacks
   * @name FeedbacksCreate
   * @request POST:/api/feedbacks/
   * @secure
   * @response `200` `Feedback`
   */
  feedbacksCreate = (data: Feedback, params: RequestParams = {}) =>
    this.request<Feedback, any>({
      path: `/api/feedbacks/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description In-app notification centre for the logged-in user. All endpoints are scoped to ``request.user`` — a user only ever sees and mutates their own notifications.
   *
   * @tags notifications
   * @name NotificationsList
   * @request GET:/api/notifications/
   * @secure
   * @response `200` `(Notification)[]`
   */
  notificationsList = (params: RequestParams = {}) =>
    this.request<Notification[], any>({
      path: `/api/notifications/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description API endpoints that allow orders to be viewed or edited.
   *
   * @tags orders
   * @name OrdersCreate
   * @request POST:/api/orders/
   * @secure
   * @response `201` `Order`
   */
  ordersCreate = (data: Order, params: RequestParams = {}) =>
    this.request<Order, any>({
      path: `/api/orders/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description API endpoints that allow quotes to be viewed or edited.
   *
   * @tags quotes-by-hash
   * @name QuotesByHashCreate
   * @request POST:/api/quotes-by-hash/
   * @secure
   * @response `201` `QuoteByHash`
   */
  quotesByHashCreate = (
    hash: string,
    data: QuoteByHash,
    params: RequestParams = {},
  ) =>
    this.request<QuoteByHash, any>({
      path: `/api/quotes-by-hash/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Mixin that disables the list and destroy actions.
   *
   * @tags quotes-by-id
   * @name QuotesByIdCreate
   * @request POST:/api/quotes-by-id/
   * @secure
   * @response `201` `QuoteByID`
   */
  quotesByIdCreate = (data: QuoteByID, params: RequestParams = {}) =>
    this.request<QuoteByID, any>({
      path: `/api/quotes-by-id/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
   *
   * @tags schema
   * @name SchemaRetrieve
   * @request GET:/api/schema/
   * @secure
   * @response `200` `Record<string,any>`
   */
  schemaRetrieve = (
    query: SchemaRetrieveParams = {},
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, any>({
      path: `/api/schema/`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description API endpoints that allow users to be viewed or edited.
   *
   * @tags users
   * @name UsersList
   * @request GET:/api/users/
   * @secure
   * @response `200` `(User)[]`
   */
  usersList = (params: RequestParams = {}) =>
    this.request<User[], any>({
      path: `/api/users/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @tags workspaces
   * @name WorkspacesList
   * @request GET:/api/workspaces/
   * @secure
   * @response `200` `(Workspace)[]`
   */
  workspacesList = (params: RequestParams = {}) =>
    this.request<Workspace[], any>({
      path: `/api/workspaces/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Create a new unverified COMPANY workspace. A VAT payer is added by VAT ID alone; a non-VAT payer must supply the company name and full address (see ``WorkspaceCreateSerializer.validate``). Branches, tried in order: 1. The user already has a COMPANY workspace with this VAT → 400, unless a VAT payer's VAT is shared by several Swida companies (or Swida cannot say): then another draft is allowed as long as no other request of the user for this VAT is still waiting at Swida, because Swida keeps one pending request per requester and VAT. 2. A VAT payer whose VAT belongs to exactly one Swida company and already has a verified IC workspace gets a join request to that workspace instead of a duplicate. The user does not become a member until an admin approves. Returns 202 with ``{join_request: true, join_request_id}``. When the VAT is shared by several Swida companies (or Swida cannot say), the verified workspace may be a different company, so this branch is skipped and Swida sales decide after verification. 3. Otherwise a fresh unverified draft is created. For a VAT payer Coface quietly fills in the name and address when it can; a draft it cannot fill is still created (named after the VAT) because Swida sales, not Coface, identify the company. The company screens show the draft's members its VAT ID instead of the stored Coface name and address until Swida verifies it.
   *
   * @tags workspaces
   * @name WorkspacesCreate
   * @request POST:/api/workspaces/
   * @secure
   * @response `201` `Workspace`
   */
  workspacesCreate = (data: Workspace, params: RequestParams = {}) =>
    this.request<Workspace, any>({
      path: `/api/workspaces/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  checkEmailVerification = {
    /**
     * @description API endpoint to check if an email is verified.
     *
     * @tags email-verification
     * @name AuthCheckEmailVerificationRetrieve
     * @request GET:/api/auth/check-email-verification/
     * @secure
     * @response `200` `void` Verification status
     * @response `400` `void` Invalid email or request format
     */
    authCheckEmailVerificationRetrieve: (
      query: AuthCheckEmailVerificationRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/auth/check-email-verification/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  landingStatus = {
    /**
     * @description Sign-in state for the Swida landing's header, read cross-site with `credentials: "include"`. Authenticates by the `ic_landing_session` cookie alone, never by a JWT. Without a valid cookie, or for an inactive account, it answers `{"logged_in": false}` with 200. Signed in, `company_name` is what IC's header shows: the active company's name (its VAT ID while it is an unverified VAT payer's draft), or the e-mail for the personal workspace.
     *
     * @tags auth
     * @name AuthLandingStatusRetrieve
     * @request GET:/api/auth/landing-status/
     * @secure
     * @response `200` `LandingStatus`
     */
    authLandingStatusRetrieve: (params: RequestParams = {}) =>
      this.request<LandingStatus, any>({
        path: `/api/auth/landing-status/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  login = {
    /**
     * @description Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework Accept the following POST parameters: username, password Return the REST Framework Token Object's key.
     *
     * @tags auth
     * @name AuthLoginCreate
     * @request POST:/api/auth/login/
     * @secure
     * @response `200` `JWT`
     */
    authLoginCreate: (data: CustomLogin, params: RequestParams = {}) =>
      this.request<JWT, any>({
        path: `/api/auth/login/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  logout = {
    /**
     * @description Calls Django logout method and delete the Token object assigned to the current User object. Accepts/Returns nothing.
     *
     * @tags auth
     * @name AuthLogoutCreate
     * @request POST:/api/auth/logout/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authLogoutCreate: (params: RequestParams = {}) =>
      this.request<RestAuthDetail, any>({
        path: `/api/auth/logout/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  password = {
    /**
     * @description Calls Django Auth SetPasswordForm save method. Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     *
     * @tags auth
     * @name AuthPasswordChangeCreate
     * @request POST:/api/auth/password/change/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authPasswordChangeCreate: (
      data: PasswordChange,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/auth/password/change/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Calls Django Auth PasswordResetForm save method. Accepts the following POST parameters: email Returns the success/fail message.
     *
     * @tags auth
     * @name AuthPasswordResetCreate
     * @request POST:/api/auth/password/reset/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authPasswordResetCreate: (
      data: PasswordReset,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/auth/password/reset/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Password reset e-mail link is confirmed, therefore this resets the user's password. Accepts the following POST parameters: token, uid, new_password1, new_password2 Returns the success/fail message.
     *
     * @tags auth
     * @name AuthPasswordResetConfirmCreate
     * @request POST:/api/auth/password/reset/confirm/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authPasswordResetConfirmCreate: (
      data: PasswordResetConfirm,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/auth/password/reset/confirm/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  register = {
    /**
     * @description Registers a new user. Accepts the following POST parameters: username, email, password1, password2.
     *
     * @tags auth
     * @name AuthRegisterCreate
     * @request POST:/api/auth/register/
     * @secure
     * @response `201` `Register`
     */
    authRegisterCreate: (data: Register, params: RequestParams = {}) =>
      this.request<Register, any>({
        path: `/api/auth/register/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Resends another email to an unverified email. Accepts the following POST parameter: email.
     *
     * @tags auth
     * @name AuthRegisterResendEmailCreate
     * @request POST:/api/auth/register/resend-email/
     * @secure
     * @response `201` `RestAuthDetail`
     */
    authRegisterResendEmailCreate: (
      data: ResendEmailVerification,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/auth/register/resend-email/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Verifies the email associated with the provided key. Accepts the following POST parameter: key.
     *
     * @tags auth
     * @name AuthRegisterVerifyEmailCreate
     * @request POST:/api/auth/register/verify-email/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authRegisterVerifyEmailCreate: (
      data: VerifyEmail,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/auth/register/verify-email/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  token = {
    /**
     * @description Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     *
     * @tags auth
     * @name AuthTokenRefreshCreate
     * @request POST:/api/auth/token/refresh/
     * @response `200` `TokenRefresh`
     */
    authTokenRefreshCreate: (data: TokenRefresh, params: RequestParams = {}) =>
      this.request<TokenRefresh, any>({
        path: `/api/auth/token/refresh/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Takes a token and indicates if it is valid.  This view provides no information about a token's fitness for a particular use.
     *
     * @tags auth
     * @name AuthTokenVerifyCreate
     * @request POST:/api/auth/token/verify/
     * @response `200` `TokenVerify`
     */
    authTokenVerifyCreate: (data: TokenVerify, params: RequestParams = {}) =>
      this.request<TokenVerify, any>({
        path: `/api/auth/token/verify/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Public endpoints used by the invite landing page. ``GET /api/invitations/{token}/`` — read-only invitation view for the unauthenticated landing page (returns workspace name, invited_by name, status, and whether a password is required). ``POST /api/invitations/{token}/accept/`` — accept and issue JWT cookies identical to a fresh login.
     *
     * @tags invitations
     * @name InvitationsRetrieve
     * @request GET:/api/invitations/{token}/
     * @secure
     * @response `200` `void` No response body
     */
    invitationsRetrieve: (token: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/invitations/${token}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Public endpoints used by the invite landing page. ``GET /api/invitations/{token}/`` — read-only invitation view for the unauthenticated landing page (returns workspace name, invited_by name, status, and whether a password is required). ``POST /api/invitations/{token}/accept/`` — accept and issue JWT cookies identical to a fresh login.
     *
     * @tags invitations
     * @name InvitationsAcceptCreate
     * @request POST:/api/invitations/{token}/accept/
     * @secure
     * @response `200` `void` No response body
     */
    invitationsAcceptCreate: (token: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/invitations/${token}/accept/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  user = {
    /**
     * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
     *
     * @tags auth
     * @name AuthUserRetrieve
     * @request GET:/api/auth/user/
     * @secure
     * @response `200` `UserDetails`
     */
    authUserRetrieve: (params: RequestParams = {}) =>
      this.request<UserDetails, any>({
        path: `/api/auth/user/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
     *
     * @tags auth
     * @name AuthUserUpdate
     * @request PUT:/api/auth/user/
     * @secure
     * @response `200` `UserDetails`
     */
    authUserUpdate: (data: UserDetails, params: RequestParams = {}) =>
      this.request<UserDetails, any>({
        path: `/api/auth/user/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
     *
     * @tags auth
     * @name AuthUserPartialUpdate
     * @request PATCH:/api/auth/user/
     * @secure
     * @response `200` `UserDetails`
     */
    authUserPartialUpdate: (
      data: PatchedUserDetails,
      params: RequestParams = {},
    ) =>
      this.request<UserDetails, any>({
        path: `/api/auth/user/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  getDefaultPriceSettings = {
    /**
     * @description API endpoint to retrieve default price settings.
     *
     * @tags default-price-settings
     * @name DefaultPriceSettingsGetDefaultPriceSettingsRetrieve
     * @request GET:/api/default-price-settings/get-default-price-settings/
     * @secure
     * @response `200` `DefaultPriceSettings`
     */
    defaultPriceSettingsGetDefaultPriceSettingsRetrieve: (
      params: RequestParams = {},
    ) =>
      this.request<DefaultPriceSettings, any>({
        path: `/api/default-price-settings/get-default-price-settings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  apply = {
    /**
     * @description API endpoint to apply a discount code to a quote.
     *
     * @tags discounts
     * @name DiscountsApplyCreate
     * @request POST:/api/discounts/apply/
     * @secure
     * @response `200` `QuoteByHash`
     */
    discountsApplyCreate: (data: ApplyDiscount, params: RequestParams = {}) =>
      this.request<QuoteByHash, any>({
        path: `/api/discounts/apply/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  subscribe = {
    /**
     * @description Subscribe an e-mail to the MailerLite newsletter group from the site footer.
     *
     * @tags newsletter
     * @name NewsletterSubscribeCreate
     * @request POST:/api/newsletter/subscribe/
     * @secure
     * @response `200` `NewsletterSubscribe`
     */
    newsletterSubscribeCreate: (
      data: NewsletterSubscribe,
      params: RequestParams = {},
    ) =>
      this.request<NewsletterSubscribe, any>({
        path: `/api/newsletter/subscribe/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  id = {
    /**
     * @description Mark a single notification as read.
     *
     * @tags notifications
     * @name NotificationsMarkReadCreate
     * @request POST:/api/notifications/{id}/mark-read/
     * @secure
     * @response `200` `Notification`
     */
    notificationsMarkReadCreate: (
      id: number,
      data: Notification,
      params: RequestParams = {},
    ) =>
      this.request<Notification, any>({
        path: `/api/notifications/${id}/mark-read/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow users to be viewed or edited.
     *
     * @tags users
     * @name UsersRetrieve
     * @request GET:/api/users/{id}/
     * @secure
     * @response `200` `User`
     */
    usersRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow users to be viewed or edited.
     *
     * @tags users
     * @name UsersUpdate
     * @request PUT:/api/users/{id}/
     * @secure
     * @response `200` `User`
     */
    usersUpdate: (id: number, data: User, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow users to be viewed or edited.
     *
     * @tags users
     * @name UsersPartialUpdate
     * @request PATCH:/api/users/{id}/
     * @secure
     * @response `200` `User`
     */
    usersPartialUpdate: (
      id: number,
      data: PatchedUser,
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/api/users/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesRetrieve
     * @request GET:/api/workspaces/{id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesUpdate
     * @request PUT:/api/workspaces/{id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesUpdate: (
      id: string,
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesPartialUpdate
     * @request PATCH:/api/workspaces/{id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesPartialUpdate: (
      id: string,
      data: PatchedWorkspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a company workspace that the user created in error. Allowed only when the workspace is: * a COMPANY workspace (never a user's personal one) * unverified and not yet linked to a Swida company * has exactly one member (the acting admin) If the deleted workspace was the user's active one, we first flip their personal workspace back to active so they aren't stranded without a selected workspace.
     *
     * @tags workspaces
     * @name WorkspacesDestroy
     * @request DELETE:/api/workspaces/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    workspacesDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/workspaces/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description POST creates a new admin access request; GET returns the current state of the latest request for the authenticated user.
     *
     * @tags workspaces
     * @name WorkspacesAdminAccessRequestRetrieve
     * @request GET:/api/workspaces/{id}/admin-access-request/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesAdminAccessRequestRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/admin-access-request/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description POST creates a new admin access request; GET returns the current state of the latest request for the authenticated user.
     *
     * @tags workspaces
     * @name WorkspacesAdminAccessRequestCreate
     * @request POST:/api/workspaces/{id}/admin-access-request/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesAdminAccessRequestCreate: (
      id: string,
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/admin-access-request/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin-only: list pending invitations or send a new one.
     *
     * @tags workspaces
     * @name WorkspacesInvitationsRetrieve
     * @request GET:/api/workspaces/{id}/invitations/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesInvitationsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/invitations/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin-only: list pending invitations or send a new one.
     *
     * @tags workspaces
     * @name WorkspacesInvitationsCreate
     * @request POST:/api/workspaces/{id}/invitations/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesInvitationsCreate: (
      id: string,
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/invitations/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin-only: revoke a pending invitation.
     *
     * @tags workspaces
     * @name WorkspacesInvitationsDestroy
     * @request DELETE:/api/workspaces/{id}/invitations/{invitation_id}/
     * @secure
     * @response `204` `void` No response body
     */
    workspacesInvitationsDestroy: (
      id: string,
      invitationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/workspaces/${id}/invitations/${invitationId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesJoinRequestsRetrieve
     * @request GET:/api/workspaces/{id}/join-requests/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesJoinRequestsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/join-requests/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List workspace members. Admins see every membership (full PII payload). Non-admins with ``can_access_company_details`` see only their own membership row — they're allowed onto the Company Details screen but must not be able to enumerate peers' emails, phones, or per-user permission flags. Anyone else gets 403.
     *
     * @tags workspaces
     * @name WorkspacesMembersRetrieve
     * @request GET:/api/workspaces/{id}/members/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesMembersRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/members/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin-only: update a member's role and view permissions, or remove them. PATCH body: any subset of ``role`` and ``can_access_invoices/company_details/loyalty``. DELETE: removes the membership (cannot remove self). Neither may take away the workspace's last admin.
     *
     * @tags workspaces
     * @name WorkspacesMembersPartialUpdate
     * @request PATCH:/api/workspaces/{id}/members/{user_id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesMembersPartialUpdate: (
      id: string,
      userId: string,
      data: PatchedWorkspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/members/${userId}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin-only: update a member's role and view permissions, or remove them. PATCH body: any subset of ``role`` and ``can_access_invoices/company_details/loyalty``. DELETE: removes the membership (cannot remove self). Neither may take away the workspace's last admin.
     *
     * @tags workspaces
     * @name WorkspacesMembersDestroy
     * @request DELETE:/api/workspaces/{id}/members/{user_id}/
     * @secure
     * @response `204` `void` No response body
     */
    workspacesMembersDestroy: (
      id: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/workspaces/${id}/members/${userId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description The caller's own transport e-mail settings in this workspace. GET returns the Transport Updates switch and the additional recipients of the caller's membership; PUT replaces them and returns the stored result. Any member may use it, personal workspaces and drafts included. The workspace comes from the URL, never from the active workspace, so a stale tab saves into the company it shows; other members' settings are never read or written.
     *
     * @tags workspaces
     * @name WorkspacesNotificationSettingsRetrieve
     * @request GET:/api/workspaces/{id}/notification-settings/
     * @secure
     * @response `200` `WorkspaceNotificationSettings`
     */
    workspacesNotificationSettingsRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceNotificationSettings, any>({
        path: `/api/workspaces/${id}/notification-settings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The caller's own transport e-mail settings in this workspace. GET returns the Transport Updates switch and the additional recipients of the caller's membership; PUT replaces them and returns the stored result. Any member may use it, personal workspaces and drafts included. The workspace comes from the URL, never from the active workspace, so a stale tab saves into the company it shows; other members' settings are never read or written.
     *
     * @tags workspaces
     * @name WorkspacesNotificationSettingsUpdate
     * @request PUT:/api/workspaces/{id}/notification-settings/
     * @secure
     * @response `200` `WorkspaceNotificationSettings`
     */
    workspacesNotificationSettingsUpdate: (
      id: string,
      data: WorkspaceNotificationSettings,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceNotificationSettings, any>({
        path: `/api/workspaces/${id}/notification-settings/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Request workspace verification. Body may include ``vat_number`` and ``company_name`` to top up a workspace that didn't have them before. A VAT payer needs only the VAT; a non-VAT payer needs the company name and full address on the workspace. Two response shapes: * ``201`` — a ``WorkspaceVerificationRequest`` was created and pushed to Swida for staff review. * ``202`` — a ``WorkspaceJoinRequest`` was created against an already-verified workspace with the same VAT (the user is asking to join an existing verified workspace instead of duplicating it); the original draft was auto-deleted when safe. Only for a VAT payer whose VAT belongs to a single Swida company; otherwise the request goes to Swida sales (201).
     *
     * @tags workspaces
     * @name WorkspacesRequestVerificationCreate
     * @request POST:/api/workspaces/{id}/request-verification/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesRequestVerificationCreate: (
      id: string,
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/request-verification/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Return the most recent verification request (any status) for the workspace. Used by the frontend to show ``pending`` / ``rejected`` button state. ``{status: null}`` if no record exists yet.
     *
     * @tags workspaces
     * @name WorkspacesVerificationRequestRetrieve
     * @request GET:/api/workspaces/{id}/verification-request/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesVerificationRequestRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/verification-request/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesVerificationRequestsRetrieve
     * @request GET:/api/workspaces/{id}/verification-requests/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesVerificationRequestsRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/${id}/verification-requests/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  clearAll = {
    /**
     * @description Delete all of the user's notifications ("Clear all" button).
     *
     * @tags notifications
     * @name NotificationsClearAllCreate
     * @request POST:/api/notifications/clear-all/
     * @secure
     * @response `200` `void` All notifications cleared.
     */
    notificationsClearAllCreate: (
      data: Notification,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/notifications/clear-all/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  unreadCount = {
    /**
     * @description Number of unread notifications — drives the bell badge.
     *
     * @tags notifications
     * @name NotificationsUnreadCountRetrieve
     * @request GET:/api/notifications/unread-count/
     * @secure
     * @response `200` `NotificationUnreadCount`
     */
    notificationsUnreadCountRetrieve: (params: RequestParams = {}) =>
      this.request<NotificationUnreadCount, any>({
        path: `/api/notifications/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  countries = {
    /**
     * No description
     *
     * @tags options
     * @name OptionsCountriesRetrieve
     * @request GET:/api/options/countries/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCountriesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/options/countries/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  quote = {
    /**
     * @description API endpoints that allow orders to be viewed or edited.
     *
     * @tags orders
     * @name OrdersRetrieve
     * @request GET:/api/orders/{quote}/
     * @secure
     * @response `200` `Order`
     */
    ordersRetrieve: (quote: number, params: RequestParams = {}) =>
      this.request<Order, any>({
        path: `/api/orders/${quote}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow orders to be viewed or edited.
     *
     * @tags orders
     * @name OrdersUpdate
     * @request PUT:/api/orders/{quote}/
     * @secure
     * @response `200` `Order` Successfully updated the order.
     * @response `400` `void` Invalid input.
     * @response `404` `void` Order not found.
     */
    ordersUpdate: (quote: number, data: Order, params: RequestParams = {}) =>
      this.request<Order, void>({
        path: `/api/orders/${quote}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow orders to be viewed or edited.
     *
     * @tags orders
     * @name OrdersPartialUpdate
     * @request PATCH:/api/orders/{quote}/
     * @secure
     * @response `200` `Order`
     */
    ordersPartialUpdate: (
      quote: number,
      data: PatchedOrder,
      params: RequestParams = {},
    ) =>
      this.request<Order, any>({
        path: `/api/orders/${quote}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  quotes = {
    /**
     * @description Partner-facing endpoint that creates a prefilled `/free-quote` deep link. Auth via `HasPartnerAPITokenPermission`; the matched `Partner` row is attached to `request.partner` so `utm_source` can be bound to identity. Body matches `POST /api/quotes-by-id/` plus optional top-level `utm_campaign` / `utm_medium` / `utm_content`. `utm_source` from the body is ignored — it is always `request.partner.slug`.
     *
     * @tags partners
     * @name PartnersQuotesCreate
     * @request POST:/api/partners/quotes/
     * @response `201` `PartnerQuoteResponse`
     */
    partnersQuotesCreate: (data: QuoteCreateByID, params: RequestParams = {}) =>
      this.request<PartnerQuoteResponse, any>({
        path: `/api/partners/quotes/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  checkoutSession = {
    /**
     * No description
     *
     * @tags payments
     * @name PaymentsCheckoutSessionCreate
     * @request POST:/api/payments/checkout-session/{hash}/
     * @secure
     * @response `200` `CheckoutResponse`
     */
    paymentsCheckoutSessionCreate: (hash: string, params: RequestParams = {}) =>
      this.request<CheckoutResponse, any>({
        path: `/api/payments/checkout-session/${hash}/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  validateWaypoints = {
    /**
     * @description Makes call to pricer with data that is required to determine if addresses are allowed.
     *
     * @tags pricing
     * @name PricingValidateWaypointsCreate
     * @request POST:/api/pricing/validate-waypoints/
     * @secure
     * @response `204` `void` No response body
     * @response `400` `Record<string,any>`
     */
    pricingValidateWaypointsCreate: (
      data: PricingValidation,
      params: RequestParams = {},
    ) =>
      this.request<void, PricingValidateWaypointsCreateError>({
        path: `/api/pricing/validate-waypoints/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  hash = {
    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashRetrieve
     * @request GET:/api/quotes-by-hash/{hash}/
     * @secure
     * @response `200` `QuoteByHash` Successfully retrieved quote.
     */
    quotesByHashRetrieve: (hash: string, params: RequestParams = {}) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdate
     * @request PUT:/api/quotes-by-hash/{hash}/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdate: (
      hash: string,
      data: QuoteByHash,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashPartialUpdate
     * @request PATCH:/api/quotes-by-hash/{hash}/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashPartialUpdate: (
      hash: string,
      data: PatchedQuoteByHash,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashAutofillCompanyCreate
     * @request POST:/api/quotes-by-hash/{hash}/autofill-company/
     * @secure
     * @response `200` `CofaceCompanyDataResponse`
     */
    quotesByHashAutofillCompanyCreate: (
      hash: string,
      data: CofaceCompanyResponse,
      params: RequestParams = {},
    ) =>
      this.request<CofaceCompanyDataResponse, any>({
        path: `/api/quotes-by-hash/${hash}/autofill-company/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashCofaceTaskCreate
     * @request POST:/api/quotes-by-hash/{hash}/coface-task/
     * @secure
     * @response `200` `number`
     * @response `400` `Record<string,any>`
     */
    quotesByHashCofaceTaskCreate: (hash: string, params: RequestParams = {}) =>
      this.request<number, QuotesByHashCofaceTaskCreateError>({
        path: `/api/quotes-by-hash/${hash}/coface-task/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashConfirmCreate
     * @request POST:/api/quotes-by-hash/{hash}/confirm/
     * @secure
     * @response `200` `QuoteByHash`
     * @response `400` `Record<string,any>`
     */
    quotesByHashConfirmCreate: (hash: string, params: RequestParams = {}) =>
      this.request<QuoteByHash, QuotesByHashConfirmCreateError>({
        path: `/api/quotes-by-hash/${hash}/confirm/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Mark quote's magic link as visited
     *
     * @tags quotes-by-hash
     * @name QuotesByHashMarkMagicLinkVisitedCreate
     * @request POST:/api/quotes-by-hash/{hash}/mark-magic-link-visited/
     * @secure
     * @response `204` `void` No response body
     */
    quotesByHashMarkMagicLinkVisitedCreate: (
      hash: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/quotes-by-hash/${hash}/mark-magic-link-visited/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdateBillingCreate
     * @request POST:/api/quotes-by-hash/{hash}/update-billing/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdateBillingCreate: (
      hash: string,
      data: QuotesByHashUpdateBillingCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/update-billing/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdatePaymentCreate
     * @request POST:/api/quotes-by-hash/{hash}/update-payment/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdatePaymentCreate: (
      hash: string,
      data: UpdatePayment,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/update-payment/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdateQuoteUserTypeCreate
     * @request POST:/api/quotes-by-hash/{hash}/update-quote-user-type/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdateQuoteUserTypeCreate: (
      hash: string,
      data: UpdateUserBillingType,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/update-quote-user-type/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update unfilled fields in waypoints
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdateQuoteWaypointsCreate
     * @request POST:/api/quotes-by-hash/{hash}/update-quote-waypoints/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdateQuoteWaypointsCreate: (
      hash: string,
      data: UpdateQuoteWaypoints,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/update-quote-waypoints/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdateSelectedPriceOptionCreate
     * @request POST:/api/quotes-by-hash/{hash}/update-selected-price-option/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdateSelectedPriceOptionCreate: (
      hash: string,
      data: UpdateSelectedPriceOption,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/update-selected-price-option/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashUpdateSpecialRequirementsCreate
     * @request POST:/api/quotes-by-hash/{hash}/update-special-requirements/
     * @secure
     * @response `200` `QuoteByHash`
     */
    quotesByHashUpdateSpecialRequirementsCreate: (
      hash: string,
      data: UpdateQuoteSpecialRequirements,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByHash, any>({
        path: `/api/quotes-by-hash/${hash}/update-special-requirements/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoints that allow quotes to be viewed or edited.
     *
     * @tags quotes-by-hash
     * @name QuotesByHashWithOrderRetrieve
     * @request GET:/api/quotes-by-hash/{hash}/with-order/
     * @secure
     * @response `200` `QuoteWithOrder`
     */
    quotesByHashWithOrderRetrieve: (hash: string, params: RequestParams = {}) =>
      this.request<QuoteWithOrder, any>({
        path: `/api/quotes-by-hash/${hash}/with-order/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  uuid = {
    /**
     * @description Mixin that disables the list and destroy actions.
     *
     * @tags quotes-by-id
     * @name QuotesByIdUpdate
     * @request PUT:/api/quotes-by-id/{uuid}/
     * @secure
     * @response `200` `QuoteByID`
     */
    quotesByIdUpdate: (
      uuid: string,
      data: QuoteByID,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByID, any>({
        path: `/api/quotes-by-id/${uuid}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Mixin that disables the list and destroy actions.
     *
     * @tags quotes-by-id
     * @name QuotesByIdPartialUpdate
     * @request PATCH:/api/quotes-by-id/{uuid}/
     * @secure
     * @response `200` `QuoteByID`
     */
    quotesByIdPartialUpdate: (
      uuid: string,
      data: PatchedQuoteByID,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByID, any>({
        path: `/api/quotes-by-id/${uuid}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves detailed information about a route, including the best route and transit time
     *
     * @tags quotes-by-id
     * @name QuotesByIdRouteDetailsCreate
     * @request POST:/api/quotes-by-id/{uuid}/route-details/
     * @secure
     * @response `200` `RouteDetailsResponse`
     * @response `400` `Record<string,any>`
     */
    quotesByIdRouteDetailsCreate: (
      uuid: string,
      data: RouteDetailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<RouteDetailsResponse, QuotesByIdRouteDetailsCreateError>({
        path: `/api/quotes-by-id/${uuid}/route-details/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates quote pricing (vehicle type, goods, special requirements) and returns calculated price
     *
     * @tags quotes-by-id
     * @name QuotesByIdUpdatePricingPartialUpdate
     * @request PATCH:/api/quotes-by-id/{uuid}/update-pricing/
     * @secure
     * @response `200` `DefaultPriceResponse`
     */
    quotesByIdUpdatePricingPartialUpdate: (
      uuid: string,
      data: PatchedUpdateQuotePricing,
      params: RequestParams = {},
    ) =>
      this.request<DefaultPriceResponse, any>({
        path: `/api/quotes-by-id/${uuid}/update-pricing/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update quote's UTM parameters with provided data
     *
     * @tags quotes-by-id
     * @name QuotesByIdUpdateUtmCreate
     * @request POST:/api/quotes-by-id/{uuid}/update-utm/
     * @secure
     * @response `200` `QuoteByID`
     */
    quotesByIdUpdateUtmCreate: (
      uuid: string,
      data: Utm,
      params: RequestParams = {},
    ) =>
      this.request<QuoteByID, any>({
        path: `/api/quotes-by-id/${uuid}/update-utm/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update quote's waypoint with provided data
     *
     * @tags quotes-by-id
     * @name QuotesByIdUpdateWaypointCreate
     * @request POST:/api/quotes-by-id/{uuid}/update-waypoint/
     * @secure
     * @response `200` `Waypoint`
     * @response `404` `Record<string,any>`
     */
    quotesByIdUpdateWaypointCreate: (
      uuid: string,
      data: Waypoint,
      params: RequestParams = {},
    ) =>
      this.request<Waypoint, QuotesByIdUpdateWaypointCreateError>({
        path: `/api/quotes-by-id/${uuid}/update-waypoint/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  me = {
    /**
     * @description API endpoints that allow users to be viewed or edited.
     *
     * @tags users
     * @name UsersMeRetrieve
     * @request GET:/api/users/me/
     * @secure
     * @response `200` `User`
     */
    usersMeRetrieve: (params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/me/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  swida = {
    /**
     * @description Swida sales picked ``company_id`` for a pending verification and want the admin of that company's verified IC workspace to decide. Payload: ``{swida_request_id, company_id}``. Answers: * ``200 {"routed": true}`` — a join request was created for the workspace admin (or already existed for this Swida request); Swida marks the request as forwarded and waits for the admin's decision, which comes back via ``admin-decision``. * ``200 {"routed": false}`` — no verified workspace with an admin exists for that company; sales approve the request themselves. * ``404`` — IC has no pending verification request with that id. * ``409`` — the requester is already a member of that workspace.
     *
     * @tags webhooks
     * @name WebhooksSwidaRouteToAdminCreate
     * @request POST:/api/webhooks/swida/route-to-admin/
     * @response `200` `RouteToAdminWebhook`
     */
    webhooksSwidaRouteToAdminCreate: (
      data: RouteToAdminWebhook,
      params: RequestParams = {},
    ) =>
      this.request<RouteToAdminWebhook, any>({
        path: `/api/webhooks/swida/route-to-admin/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Swida has resolved a workspace verification request. Approve payload:  ``{swida_request_id, approved: True, company_id, company_name, multi_company_vat, note}`` Reject payload:   ``{swida_request_id, approved: False, note}`` On approval IC flips ``workspace.is_verified = True``, sets the Swida company linkage, renames the workspace to ``company_name`` and auto-promotes the requester to ADMIN. ``multi_company_vat`` keeps the VAT-based duplicate-draft cleanup away from drafts that may belong to a sibling company under the same VAT.
     *
     * @tags webhooks
     * @name WebhooksSwidaVerificationResolvedCreate
     * @request POST:/api/webhooks/swida/verification-resolved/
     * @response `200` `VerificationResolvedWebhook`
     */
    webhooksSwidaVerificationResolvedCreate: (
      data: VerificationResolvedWebhook,
      params: RequestParams = {},
    ) =>
      this.request<VerificationResolvedWebhook, any>({
        path: `/api/webhooks/swida/verification-resolved/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  active = {
    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesActiveRetrieve
     * @request GET:/api/workspaces/active/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesActiveRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/active/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  invoicePdf = {
    /**
     * @description Proxy endpoint to download/view invoice PDF from Swida.
     *
     * @tags workspaces
     * @name WorkspacesInvoicePdfRetrieve
     * @request GET:/api/workspaces/invoice-pdf/{invoice_id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesInvoicePdfRetrieve: (
      invoiceId: string,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/invoice-pdf/${invoiceId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  invoices = {
    /**
     * @description Get invoices for the active workspace. Only available for verified workspaces with a company ID.
     *
     * @tags workspaces
     * @name WorkspacesInvoicesRetrieve
     * @request GET:/api/workspaces/invoices/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesInvoicesRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/invoices/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  joinRequests = {
    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesJoinRequestsResolveCreate
     * @request POST:/api/workspaces/join-requests/{request_id}/resolve/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesJoinRequestsResolveCreate: (
      requestId: string,
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/join-requests/${requestId}/resolve/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  loyalty = {
    /**
     * @description The company's loyalty point balance + program rules (drives the badge, the <20-points greyed-out catalogue gate, and the rules section).
     *
     * @tags workspaces
     * @name WorkspacesLoyaltyBalanceRetrieve
     * @request GET:/api/workspaces/loyalty/balance/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesLoyaltyBalanceRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/loyalty/balance/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description CLIENT gadget catalogue from Swida for the active workspace's company.
     *
     * @tags workspaces
     * @name WorkspacesLoyaltyGadgetsRetrieve
     * @request GET:/api/workspaces/loyalty/gadgets/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesLoyaltyGadgetsRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/loyalty/gadgets/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description GET: the company's merch-order history. POST: place a merch order (redeem points). ``company_id`` is injected from the verified workspace — never trusted from the client body.
     *
     * @tags workspaces
     * @name WorkspacesLoyaltyOrdersRetrieve
     * @request GET:/api/workspaces/loyalty/orders/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesLoyaltyOrdersRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/loyalty/orders/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description GET: the company's merch-order history. POST: place a merch order (redeem points). ``company_id`` is injected from the verified workspace — never trusted from the client body.
     *
     * @tags workspaces
     * @name WorkspacesLoyaltyOrdersCreate
     * @request POST:/api/workspaces/loyalty/orders/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesLoyaltyOrdersCreate: (
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/loyalty/orders/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  myJoinRequests = {
    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesMyJoinRequestsRetrieve
     * @request GET:/api/workspaces/my-join-requests/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesMyJoinRequestsRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/my-join-requests/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  orders = {
    /**
     * @description Get orders for the active workspace. Verified carriers (with company_id): orders from the Swida API only. Unverified carriers: orders from the IC database only.
     *
     * @tags workspaces
     * @name WorkspacesOrdersRetrieve
     * @request GET:/api/workspaces/orders/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesOrdersRetrieve: (params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/orders/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  switch = {
    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesSwitchCreate
     * @request POST:/api/workspaces/switch/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesSwitchCreate: (data: Workspace, params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/switch/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  verificationRequests = {
    /**
     * No description
     *
     * @tags workspaces
     * @name WorkspacesVerificationRequestsResolveCreate
     * @request POST:/api/workspaces/verification-requests/{request_id}/resolve/
     * @secure
     * @response `200` `Workspace`
     */
    workspacesVerificationRequestsResolveCreate: (
      requestId: string,
      data: Workspace,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/workspaces/verification-requests/${requestId}/resolve/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
